import React, { useEffect, useState } from "react";
import Header from "../../Components/Header/header";
import { FaTrash, FaEdit, FaFilter } from "react-icons/fa";
import { FaPlus } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import EmployeeBulkUpload from "../../pages/employeemanagement/EmployeeBulkUpload.jsx";
import { FaTimes } from "react-icons/fa";

import "./employeemanagement.css";
import * as XLSX from "xlsx";

const EmployeeManagement = () => {
    const [schemes, setSchemes] = useState([]);
    const [employees, setEmployees] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [dobError, setDobError] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [activeTab, setActiveTab] = useState("");
    const [showSchemePopup, setShowSchemePopup] = useState(false);
    
    const [showSchemeListPopup, setShowSchemeListPopup] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [empIdError, setEmpIdError] = useState("");
    const [employeesSubmitted, setEmployeesSubmitted] = useState(false);
    const [schemeList, setSchemeList] = useState([]);
    const [filterCategory, setFilterCategory] = useState("");
    const [existingDependentData, setExistingDependentData] = useState({});
    const [showEndorsementPopup, setShowEndorsementPopup] = useState(false);
    const [sentEndorsements, setSentEndorsements] = useState([]);
    const [schemeInsurer, setSchemeInsurer] = useState("");
    const [loadingSchemes, setLoadingSchemes] = useState(false);
    const [categories, setCategories] = useState([]);
    const [showMailPopup, setShowMailPopup] = useState(false);
    const [selectedScheme, setSelectedScheme] = useState(null);
    const [file, setFile] = useState(null);
    const [showNoSchemePopup, setShowNoSchemePopup] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState("");
    const [customCategory, setCustomCategory] = useState("");
    const [existingDependents, setExistingDependents] = useState({});
    const [loading, setLoading] = useState(false);
    const [showDeactivatePopup, setShowDeactivatePopup] = useState(false);
    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const [fileParsedEmployees, setFileParsedEmployees] = useState([]);
    const [originalEmployee, setOriginalEmployee] = useState(null);
    const [showBulkPopup, setShowBulkPopup] = useState(false);
    const [fileName, setFileName] = useState("");
    const [isNoSchemeList, setIsNoSchemeList] = useState(false);
    const [selectedEmployeeScheme, setSelectedEmployeeScheme] = useState(null);
    const [categoriesList, setCategoriesList] = useState([]);
    const [mismatchedCategories, setMismatchedCategories] = useState([]); // values from file that don't match org categories
    const [categoryMappings, setCategoryMappings] = useState({}); // { originalValue: { type: 'existing'|'create', cat_id?, cat_org_custom_name? , new_custom_name? } }
    const [showCategoryMatchPopup, setShowCategoryMatchPopup] = useState(false);
    const [mappingLoading, setMappingLoading] = useState(false);
    const [categoriesFromServer, setCategoriesFromServer] = useState([]); // org-specific categories
    const [showCategorySection, setShowCategorySection] = useState(true);
    const [submittedEmployees, setSubmittedEmployees] = useState([]);
    const [showEmployeeSchemePopup, setShowEmployeeSchemePopup] = useState(false);
    const [schemePreviewData, setSchemePreviewData] = useState(null);
    const [showEndorsementTrackPopup, setShowEndorsementTrackPopup] = useState(false);
    const [emails, setEmails] = useState([""]);
    const [addAnother, setAddAnother] = useState(false);
    const [additionalEmail, setAdditionalEmail] = useState(""); // extra email
    const [addMoreEmail, setAddMoreEmail] = useState(false);
    const [endorsementNumber, setEndorsementNumber] = useState("");
    const [fileCategoryValues, setFileCategoryValues] = useState([]);
    const [remarks, setRemarks] = useState("");
    const [childCount, setChildCount] = useState(0);
    const [children, setChildren] = useState([]);
    const [sendingMail, setSendingMail] = useState(false);
    const [showAddDependentPopup, setShowAddDependentPopup] = useState(false);
    const [allowedRelations, setAllowedRelations] = useState({});
    const [showViewDependentPopup, setShowViewDependentPopup] = useState(false);
    const [schemeFamilyText, setSchemeFamilyText] = useState("");
    const [showEmailPopup, setShowEmailPopup] = useState(false);
    const [insurerDetails, setInsurerDetails] = useState(null);
    const [emailToSend, setEmailToSend] = useState("");
    const [user, setUser] = useState(null);
    // ✅ For loading state while fetching track data
    const [loadingTrack, setLoadingTrack] = useState(false);
    const [selectedInsurer, setSelectedInsurer] = useState("");
    const [showFilter, setShowFilter] = useState(false);
    // ✅ Store fetched endorsement track records
    const [endorsementTrack, setEndorsementTrack] = useState([]);
    const [viewDependentData, setViewDependentData] = useState(null);
    const [sendingDeletionMail, setSendingDeletionMail] = useState(false);
    const [isSending, setIsSending] = useState(false);
    // ✅ Store the employee selected for viewing track
    const [childCountInput, setChildCountInput] = useState("");
const [showDeactiveEmployeePopup, setShowDeactiveEmployeePopup] = useState(false);
    // ✅ Store the track selected for editing
    const [selectedTrack, setSelectedTrack] = useState(null);
const [pendingEmployees, setPendingEmployees] = useState([]);
const [loadingAction, setLoadingAction] = useState(null);
const [pendingDeleteEmployees, setPendingDeleteEmployees] = useState([]);
const [filteredDeleteEmployees, setFilteredDeleteEmployees] = useState([]);
const [deleteInsurerList, setDeleteInsurerList] = useState([]);
const [selectedDeleteInsurer, setSelectedDeleteInsurer] = useState("");
const [deleteTotalRemainingBalance, setDeleteTotalRemainingBalance] = useState(0);
const [showDeleteFilter, setShowDeleteFilter] = useState(false);

const [manualEmail, setManualEmail] = useState("");
const [totalRemainingBalance, setTotalRemainingBalance] = useState(0);
    const [showPanel, setShowPanel] = useState(false);

const [deactiveEmployees, setDeactiveEmployees] = useState([]);
const [showCdPopup, setShowCdPopup] = useState(false);
const [cdPopupData, setCdPopupData] = useState({});

    const [contacts, setContacts] = useState([
        { name: "", email: "", file: null }
    ]);

   
    const MAX_CONTACTS = 5;
    // ✅ Show edit track popup
    const [showEditTrackPopup, setShowEditTrackPopup] = useState(false);
    const location = useLocation();

    const navigate = useNavigate();

    const isEditMode = !!originalEmployee;
const insurerList = [
    ...new Set(
        sentEndorsements
            .map((e) => e.insurer)
            .filter(Boolean)
    )
];

const formatDate = (date) => {
  if (!date) return "-";
  return new Date(date).toISOString().split("T")[0];
};
const filteredEndorsements = selectedInsurer
    ? sentEndorsements.filter(
          (e) => e.insurer === selectedInsurer
      )
    : sentEndorsements;

    // State
    const [formData, setFormData] = useState({
        scheme_id: [], // store multiple scheme IDs
        emp_id: "",
        emp_name: "",
        emp_email_id: "",
        designation: "",
        dob: "",
        age: "",
        spouse_name: "",
        spouse_dob: "",
        child_name: "",
        child_dob: "",
        father_name: "",
        father_dob: "",
        mother_name: "",
        mother_dob: "",
        father_inlaw_name: "",
        father_inlaw_dob: "",
        mother_inlaw_name: "",
        mother_inlaw_dob: "",
    });
    const [selectedSchemes, setSelectedSchemes] = useState([]); // store all selected schemes

    const [dependentForm, setDependentForm] = useState({
        emp_id: "",
        emp_name: "",
        scheme_id: "",
        spouse_name: "",
        spouse_dob: "",
        child_name: "",
        child_dob: "",
        child2_name: "",
        child2_dob: "",
        child3_name: "",
        child3_dob: "",
        father_name: "",
        father_dob: "",
        mother_name: "",
        mother_dob: "",
        father_inlaw_name: "",
        father_inlaw_dob: "",
        mother_inlaw_name: "",
        mother_inlaw_dob: "",
    });

 

    const [editPermissions, setEditPermissions] = useState({
        spouse: false,
        child: false,
        parents: false,
        inlaws: false
    });


    const [currentPage, setCurrentPage] = useState(1);
const recordsPerPage = 10;


// 🔎 Filter employees
const filteredEmployees = Array.isArray(employees)
  ? employees.filter((emp) => {
      const search = searchTerm.toLowerCase();

      const matchesSearch =
        emp.emp_name?.toLowerCase().includes(search) ||
        emp.emp_id?.toString().includes(search);

      const matchesCategory =
        filterCategory === "" ||
        emp.cat_id?.toString() === filterCategory;

      return matchesSearch && matchesCategory;
    })
  : [];

// 📄 Pagination
const indexOfLastRecord = currentPage * recordsPerPage;
const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;

const currentEmployees = filteredEmployees.slice(
    indexOfFirstRecord,
    indexOfLastRecord
);

const totalPages = Math.ceil(filteredEmployees.length / recordsPerPage);

    const today = new Date();


    
    const maxDate = today.toISOString().split("T")[0]; // today (no future)

    const twoMonthsBack = new Date();
    twoMonthsBack.setMonth(twoMonthsBack.getMonth() - 2);

    const minDate = twoMonthsBack.toISOString().split("T")[0]; // only 2 months back

    // ✅ Page count based on filtered data
    useEffect(() => {
        setCurrentPage(1);
    }, [searchTerm, filterCategory]);

     useEffect(() => {
            const storedUser = localStorage.getItem("user");
            if (storedUser) {
                setUser(JSON.parse(storedUser));
            }
        }, []);
    const orgId = Number(localStorage.getItem("org_id"));

    const fetchDependentData = async (empId) => {
    try {
        const res = await fetch(
            `/api/dependents/${empId}/${orgId}`
        );

        const data = await res.json();

        if (data.success) {
            setViewDependentData(data.data);        // editable copy
            setExistingDependentData(data.data);    // original copy for comparison
            setShowViewDependentPopup(true);
        }
    } catch (error) {
        console.error("Error fetching dependents:", error);
    }
};

    const getVisiblePages = () => {
        const pages = [];
        const maxVisible = 5;
        let start = Math.max(1, currentPage - 2);
        let end = Math.min(totalPages, start + maxVisible - 1);

        if (end - start < maxVisible - 1) {
            start = Math.max(1, end - maxVisible + 1);
        }

        for (let i = start; i <= end; i++) {
            pages.push(i);
        }
        return pages;
    };


    const handleNext = () => {
        if (currentPage < totalPages) setCurrentPage(currentPage + 1);
    };

    const handlePrev = () => {
        if (currentPage > 1) setCurrentPage(currentPage - 1);
    };

   
const getTodayDate = () => {
  return new Date().toISOString().split("T")[0];
};

const [cdForm, setCdForm] = useState({
  date: getTodayDate(),   // ✅ auto-filled
  receiptNo: "",
  amount: ""
});


 
    const handlePageClick = (pageNum) => setCurrentPage(pageNum);

    // useEffect(() => {
    //     if (!orgId) return;

    //     console.log("Fetching employees for orgId:", orgId);

    //     const fetchEmployees = async () => {
    //         try {
    //             setLoading(true);

    //             const res = await fetch(`/api/employeemanagement/org/${orgId}`);
    //             const data = await res.json();

    //             console.log("Employees fetched:", data);

    //             setEmployees(data);
    //         } catch (error) {
    //             console.error("Error fetching employees:", error);
    //         } finally {
    //             setLoading(false);
    //         }
    //     };

    //     fetchEmployees();
    // }, [orgId]);

useEffect(() => {
    const fetchPausedPremium = async () => {
        try {
            const orgId = localStorage.getItem("org_id");

            const res = await fetch(
                `/api/endorsement/pending-total/${orgId}`
            );

            const data = await res.json();

            if (data.success) {
                localStorage.setItem("pausedPremium", data.total);
            }
        } catch (err) {
            console.error("Paused premium fetch error:", err);
        }
    };

    fetchPausedPremium();
}, []);

useEffect(() => {
    if (!orgId || isNaN(orgId)) return;

    console.log("Fetching employees for orgId:", orgId);

    const fetchEmployees = async () => {
        try {
            setLoading(true);

            const res = await fetch(
                `/api/employeemanagement/org/${orgId}`
            );

            const data = await res.json();

            if (Array.isArray(data)) {
                setEmployees(data);
            } else {
                console.error("Unexpected API response:", data);
                setEmployees([]);
            }

        } catch (error) {
            console.error("Error fetching employees:", error);
            setEmployees([]);
        } finally {
            setLoading(false);
        }
    };

    fetchEmployees();
}, [orgId]);

    const openSchemeListPopup = (employeeRecord) => {
        setFormData({
            ...employeeRecord,
            child_name: employeeRecord.child_name || "",
            child_dob: employeeRecord.child_dob || "",
            child2_name: employeeRecord.child2_name || "",
            child2_dob: employeeRecord.child2_dob || "",
            child3_name: employeeRecord.child3_name || "",
            child3_dob: employeeRecord.child3_dob || "",
            spouse_name: employeeRecord.spouse_name || "",
            spouse_dob: employeeRecord.spouse_dob || "",
            father_name: employeeRecord.father_name || "",
            father_dob: employeeRecord.father_dob || "",
            mother_name: employeeRecord.mother_name || "",
            mother_dob: employeeRecord.mother_dob || "",
            father_inlaw_name: employeeRecord.father_inlaw_name || "",
            father_inlaw_dob: employeeRecord.father_inlaw_dob || "",
            mother_inlaw_name: employeeRecord.mother_inlaw_name || "",
            mother_inlaw_dob: employeeRecord.mother_inlaw_dob || "",
            scheme_id: [], // start with empty selected schemes
        });

        setSelectedSchemes([]);
        // clear previous selections
        setShowSchemeListPopup(true);
    };


    const formatDateForInput = (date) => {
        if (!date) return "";
        const d = new Date(date);
        const month = (d.getMonth() + 1).toString().padStart(2, "0");
        const day = d.getDate().toString().padStart(2, "0");
        const year = d.getFullYear();
        return `${year}-${month}-${day}`;
    };


  const handleSendMail = async () => {

    if (filteredEndorsements.length === 0) {
        alert("No records to send");
        return;
    }

    const email = prompt("Enter email address:");
    if (!email) return;

    const orgId = Number(localStorage.getItem("org_id"));

    try {

        setSendingMail(true); // start loading

        const res = await fetch("/api/send-endorsement-mail", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                data: filteredEndorsements,
                email: email,
                orgId: orgId
            })
        });

        const result = await res.json();
        alert(result.message);

    } catch (error) {

        console.error(error);
        alert("Error sending mail");

    } finally {

        setSendingMail(false); // stop loading

    }
};
    const handleSendToInsurer = async (index) => {
        const contact = contacts[index];

        if (!contact.contactEmail || !contact.attachment) {
            alert("Email and attachment required");
            return;
        }

        const formData = new FormData();
        formData.append("email", contact.contactEmail);
        formData.append("insurer", contact.insurer);
        formData.append("attachment", contact.attachment);

        try {
            const res = await fetch("/api/send-insurer-mail", {
                method: "POST",
                body: formData,
            });

            const data = await res.json();

            if (data.success) {
                alert("Mail sent successfully");
            } else {
                alert("Failed to send mail");
            }
        } catch (err) {
            console.error(err);
            alert("Server error");
        }
    };

const handledeletionSendMail = async () => {

    if (filteredDeleteEmployees.length === 0) {
        alert("No records to send");
        return;
    }

    const email = prompt("Enter email address:");
    if (!email) return;

    const orgId = Number(localStorage.getItem("org_id"));

    try {

        setSendingDeletionMail(true); // start loading

        const res = await fetch("/api/send-deletion-mail", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                employees: filteredDeleteEmployees,
                email: email,
                orgId: orgId
            })
        });

        const result = await res.json();

        alert(result.message);

    } catch (error) {

        console.error(error);
        alert("Error sending mail");

    } finally {

        setSendingDeletionMail(false); // stop loading

    }
};
    useEffect(() => {
        if (!formData.cat_org_custom_name) return;

        const fetchSchemesByCategory = async () => {
            setLoadingSchemes(true);

            const orgId = localStorage.getItem("org_id");
            if (!orgId) {
                console.error("Org ID missing");
                return;
            }

            try {
                const res = await fetch(
                    `/api/employeemanagement/schemes?org_id=${orgId}&cat_name=${encodeURIComponent(formData.cat_org_custom_name)}`
                );

                const data = await res.json();
                setSchemeList(Array.isArray(data) ? data : []);

                if (Array.isArray(data) && data.length === 0) {
                    alert(
                        `No scheme found for category "${formData.cat_org_custom_name}". Please create a new scheme.`
                    );
                }

            } catch (err) {
                console.error("Error fetching schemes:", err);
                setSchemeList([]);
            } finally {
                setLoadingSchemes(false);
            }
        };

        fetchSchemesByCategory();
    }, [formData.cat_org_custom_name]);

    useEffect(() => {
        if (!selectedEmployee) return;

        const fetchEmployeeScheme = async () => {
            try {
                const res = await fetch(`/api/employee-scheme/${selectedEmployee.emp_id}`);
                const data = await res.json();
                console.log("🔍 Employee Scheme:", data);
                setSelectedEmployeeScheme(
                    Array.isArray(data) && data.length > 0 ? data[0] : null
                );
            } catch (err) {
                console.error("❌ Error fetching employee scheme:", err);
            }
        };

        fetchEmployeeScheme();
    }, [selectedEmployee]);

    useEffect(() => {
  if (showCdPopup) {
    setCdForm(prev => ({
      ...prev,
      date: new Date().toISOString().split("T")[0]
    }));
  }
}, [showCdPopup]);

    // useEffect(() => {
    //         if (!showPanel) return; // Only fetch when panel opens
    
    //         const fetchPendingInsurers = async () => {
    //             const orgId = localStorage.getItem("org_id");
    //             if (!orgId) {
    //                 console.error("Org ID missing");
    //                 return;
    //             }
    
    //             try {
    //                 // Include full backend URL with port
    //                 const res = await fetch(`/api/pending-insurers/${orgId}`);
    //                 const data = await res.json();
    
    //                 if (data.success && Array.isArray(data.data)) {
    //                     const insurers = data.data.map(item => ({
    //                         insurer: item.insurer || "",
    //                         contactName: "",
    //                         contactEmail: "",
    //                         attachment: null,
    //                     }));
    //                     setContacts(insurers);
    //                     console.log("Fetched insurers:", insurers);
    //                 } else {
    //                     setContacts([]);
    //                     console.log("No insurers returned from backend");
    //                 }
    //             } catch (err) {
    //                 console.error("Error fetching pending insurers:", err);
    //                 setContacts([]);
    //             }
    //         };
    
    //         fetchPendingInsurers();
    //     }, [showPanel]);
    

useEffect(() => {

    if (!showEndorsementPopup) return;

    const fetchPendingInsurers = async () => {

        const orgId = localStorage.getItem("org_id");

        if (!orgId) {
            console.error("Org ID missing");
            return;
        }

        try {

            const res = await fetch(
                `/api/pending-insurers/${orgId}`
            );

            const data = await res.json();

            console.log("API RESPONSE:", data);

            if (data.success && Array.isArray(data.data)) {

                setSentEndorsements(data.data);

            } else {

                setSentEndorsements([]);
            }

        } catch (err) {

            console.error("Error fetching pending insurers:", err);

            setSentEndorsements([]);
        }
    };

    fetchPendingInsurers();

}, [showEndorsementPopup]);


    const fetchEmployeeData = (orgId) => {
        fetch(`/api/org-employees/${orgId}`, {
            method: "POST",
        })
            .then((res) => res.json())
            .then((data) => {
                const mergedData = [];
                data.employees?.forEach((emp) =>
                    mergedData.push({ ...emp, relation: "Employee" })
                );
                data.spouses?.forEach((sp) =>
                    mergedData.push({ ...sp, relation: "Spouse" })
                );
                data.children?.forEach((ch) =>
                    mergedData.push({ ...ch, relation: "Child" })
                );
                data.parents?.forEach((p) =>
                    mergedData.push({ ...p, relation: "Parent" })
                );
                data.inlaws?.forEach((il) =>
                    mergedData.push({ ...il, relation: "In-Law" })
                );

                const finalData = mergedData.map((emp) => ({
                    ...emp,
                    age: emp.dob ? calculateAge(emp.dob) : "",
                }));

                setSubmittedEmployees(finalData);
            })
            .catch((err) => console.error("❌ Error fetching employees:", err));
    };



    useEffect(() => {
        fetch(`/api/categories/org/${orgId}`)
            .then(res => res.json())
            .then(data => setCategories(Array.isArray(data.categories) ? data.categories : []))
            .catch(err => console.error("Error loading categories", err));
    }, [orgId]);


    useEffect(() => {
        if (showPopup && formData.cat_id) {
            fetch(`/api/categories/${formData.cat_id}`)
                .then(res => res.json())
                .then(data => {
                    console.log("Fetched category:", data);
                    setCategoriesList(data);
                })
                .catch(err => console.error("Error fetching category", err));
        }
    }, [showPopup, formData.cat_id]);

    const fetchCategoriesByOrg = async () => {
        const orgId = localStorage.getItem("org_id");
        if (!orgId) {
            console.error("Organization ID not found in localStorage");
            return;
        }

        try {
            const res = await fetch(`/api/categories/org/${orgId}`);
            const data = await res.json();

            if (data.success) {
                // Remove duplicates based on cat_org_custom_name
                const uniqueCategories = [
                    ...new Map(
                        data.rows.map(item => [item.cat_org_custom_name, item])
                    ).values()
                ];
                setCategories(uniqueCategories);
            } else {
                console.error("Failed to fetch categories:", data.message);
            }
        } catch (err) {
            console.error("Error fetching categories:", err);
        }
    };

    useEffect(() => {
        fetchCategoriesByOrg();
    }, []);


   const fetchPendingEmployees = async () => {
    try {

        const res = await fetch(
            "/api/pending-deletion-employees"
        );

        const data = await res.json();

        if (data.success) {

            setPendingDeleteEmployees(data.employees);
            setFilteredDeleteEmployees(data.employees);
            setDeleteTotalRemainingBalance(data.totalRemainingBalance);

            const insurers = [
                ...new Set(data.employees.map((e) => e.insurer)),
            ];

            setDeleteInsurerList(insurers);

        }

    } catch (err) {
        console.error("Error fetching employees:", err);
    }
};


useEffect(() => {

    if (!selectedDeleteInsurer) {
        setFilteredDeleteEmployees(pendingDeleteEmployees);
    } 
    else {
        const filtered = pendingDeleteEmployees.filter(
            (e) => e.insurer === selectedDeleteInsurer
        );

        setFilteredDeleteEmployees(filtered);
    }

}, [selectedDeleteInsurer, pendingDeleteEmployees]);

    const buildChildrenFromEmployee = (emp) => {
        const children = [];

        const mappings = [
            { name: emp.child_name, dob: emp.child_dob },
            { name: emp.child2_name || emp.child_2_name, dob: emp.child2_dob || emp.child_2_dob },
            { name: emp.child3_name || emp.child_3_name, dob: emp.child3_dob || emp.child_3_dob }
        ];

        mappings.forEach((c) => {
            if (c.name && c.name.trim() !== "") {
                children.push({
                    name: c.name,
                    dob: c.dob ? c.dob.split("T")[0] : ""
                });
            }
        });

        return children;
    };

const fetchPendingDeletionEmployees = async () => {

    try {

        const response = await fetch(
            "/api/pending-deletion-employees"
        );

        const data = await response.json();

        if (data.success) {

            setFilteredDeleteEmployees(data.employees);

            setDeleteTotalRemainingBalance(
                data.totalRemainingBalance
            );

        }

    } catch (err) {

        console.error(
            "Error fetching inactive employees:",
            err
        );
    }
};

useEffect(() => {
    fetchPendingDeletionEmployees();
}, []);

const handleInactiveUserBalance = async () => {

    try {

        const response = await fetch(
            "/api/add-inactive-balance-to-cd",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                }
            }
        );

        const data = await response.json();

        if (!response.ok || !data.success) {
            throw new Error(data.message);
        }

        alert("✅ Remaining balance added to CD balance successfully");

        // refresh data if needed
        fetchPendingDeletionEmployees();

    } catch (err) {

        console.error(err);

        alert(err.message || "Failed to update CD balance");
    }
};


    const hasData = (key) => {
        if (!Array.isArray(endorsementTrack)) return false;

        return endorsementTrack.some(
            row => row?.[key] !== null && row?.[key] !== undefined && row?.[key] !== ""
        );
    };

    const showChild = hasData("child");
    const showChildDob = hasData("child_dob");

    const showChild2 = hasData("child2_name");
    const showChild2Dob = hasData("child2_dob");

    const showChild3 = hasData("child3_name");
    const showChild3Dob = hasData("child3_dob");

    const showMother = hasData("mother_name");
    const showMotherDob = hasData("mother_dob");

    const showFather = hasData("father_name");
    const showFatherDob = hasData("father_dob");

    const showMotherInLaw = hasData("mother_inlaw_name");
    const showMotherInLawDob = hasData("mother_inlaw_dob");

    const showFatherInLaw = hasData("father_inlaw_name");
    const showFatherInLawDob = hasData("father_inlaw_dob");


    const parseAgeFromDob = (dobStr) => {
        if (!dobStr) return 0;

        // Remove whitespace and newlines
        const cleanDob = String(dobStr).trim();

        const dob = new Date(cleanDob);
        if (isNaN(dob.getTime())) return 0;

        const now = new Date();
        return Math.floor(
            (now - dob) / (365.25 * 24 * 60 * 60 * 1000)
        );
    };

    // ------------------- reusable function -------------------
  const fetchEmployees = async () => {
  try {
    const storedUser = JSON.parse(localStorage.getItem("user"));

    if (!storedUser?.org_id) {
      console.log("No org_id found");
      return;
    }

    const res = await fetch(
      `/api/employeemanagement/org/${storedUser.org_id}`
    );

    const data = await res.json();

    console.log("API DATA:", data);

    setEmployees(Array.isArray(data) ? data : []);
  } catch (err) {
    console.error("Error fetching employees:", err);
    setEmployees([]);
  }
};

useEffect(() => {
  fetchEmployees();
}, []);

    const fetchFamilyDefinition = async (schemeId) => {
        try {
            const res = await fetch(`/api/schemetable/${schemeId}`);
            const data = await res.json();

            if (data) {
                setAllowedRelations({
                    spouse: data.family_spouse || false,
                    children: data.family_child ? data.no_of_children || 1 : 0,
                    parents: data.family_parents || false,
                    inlaws: data.family_inlaws || false,
                });
            }
        } catch (err) {
            console.error("Error fetching family definition:", err);
        }
    };

    const diffInDays = (start, end) => {
        const s = new Date(start);
        const e = new Date(end);
        const diffTime = e.getTime() - s.getTime();
        return Math.max(Math.ceil(diffTime / (1000 * 60 * 60 * 24)), 0);
    };

    const getAges = (dob) => {
        const birth = new Date(dob);
        const today = new Date();
        let age = today.getFullYear() - birth.getFullYear();
        const m = today.getMonth() - birth.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) age--;
        return age;
    };


//     const calculateDependentPremium = async (dependentForm) => {
//     const dependents = [];

//     // ✅ Spouse
//     if (
//         allowedRelations.spouse &&
//         dependentForm.spouse_dob &&
//         dependentForm.spouse_name &&
//         dependentForm.spouse_dob !== existingDependents.spouse_dob
//     ) {
//         dependents.push({ dob: dependentForm.spouse_dob });
//     }

//     // ✅ Children
//     for (let i = 0; i < allowedRelations.children; i++) {
//         const nameKey = i === 0 ? "child_name" : `child${i + 1}_name`;
//         const dobKey = i === 0 ? "child_dob" : `child${i + 1}_dob`;

//         if (
//             dependentForm[dobKey] &&
//             dependentForm[nameKey] &&
//             dependentForm[dobKey] !== existingDependents[dobKey]
//         ) {
//             dependents.push({ dob: dependentForm[dobKey] });
//         }
//     }

//     // ✅ Parents
//     if (allowedRelations.parents) {
//         if (
//             dependentForm.father_dob &&
//             dependentForm.father_name &&
//             dependentForm.father_dob !== existingDependents.father_dob
//         ) {
//             dependents.push({ dob: dependentForm.father_dob });
//         }

//         if (
//             dependentForm.mother_dob &&
//             dependentForm.mother_name &&
//             dependentForm.mother_dob !== existingDependents.mother_dob
//         ) {
//             dependents.push({ dob: dependentForm.mother_dob });
//         }
//     }

//     // ✅ In-laws
//     if (allowedRelations.inlaws) {
//         if (
//             dependentForm.father_inlaw_dob &&
//             dependentForm.father_inlaw_name &&
//             dependentForm.father_inlaw_dob !== existingDependents.father_inlaw_dob
//         ) {
//             dependents.push({ dob: dependentForm.father_inlaw_dob });
//         }

//         if (
//             dependentForm.mother_inlaw_dob &&
//             dependentForm.mother_inlaw_name &&
//             dependentForm.mother_inlaw_dob !== existingDependents.mother_inlaw_dob
//         ) {
//             dependents.push({ dob: dependentForm.mother_inlaw_dob });
//         }
//     }

//     // 🚨 No new dependents
//     if (dependents.length === 0) {
//         return { premium: 0, gst: 0, total_premium: 0, total_sum_insured: 0 };
//     }

//     let annualPremiumTotal = 0;
//     let totalSumInsured = 0;

//     for (const dep of dependents) {
//         const age = getAges(dep.dob);

//         const res = await fetch(
//             `/api/premium-rates?policy_id=${dependentForm.policy_id}&age=${age}`
//         );

//         const data = await res.json();

//         console.log("🔥 API Response:", data);

//         if (data?.total_premium) {
//             annualPremiumTotal += Number(data.total_premium);
//         }

//         if (data?.total_sum_insured) {
//             totalSumInsured = data.total_sum_insured; // same for all dependents
//         }
//     }

//     const totalPolicyDays = diffInDays(
//         dependentForm.policy_start_date,
//         dependentForm.policy_end_date
//     );

//     const remainingDays = diffInDays(
//         new Date(),
//         dependentForm.policy_end_date
//     );

//     const prorationFactor =
//         totalPolicyDays > 0 ? remainingDays / totalPolicyDays : 1;

//     const proratedPremium = annualPremiumTotal * prorationFactor;
//     const gstAmount = proratedPremium * ((dependentForm.gst || 18) / 100);

//     return {
//         premium: Math.round(proratedPremium),
//         gst: Math.round(gstAmount),
//         total_premium: Math.round(proratedPremium + gstAmount),
//         total_sum_insured: totalSumInsured, // ✅ IMPORTANT
//     };
// };


const calculateDependentPremium = async (dependentForm) => {
    const dependents = [];

    // ✅ Spouse
    if (
        allowedRelations.spouse &&
        dependentForm.spouse_dob &&
        dependentForm.spouse_name &&
        dependentForm.spouse_dob !== existingDependents.spouse_dob
    ) {
        dependents.push({ dob: dependentForm.spouse_dob });
    }

    // ✅ Children
    for (let i = 0; i < allowedRelations.children; i++) {
        const nameKey = i === 0 ? "child_name" : `child${i + 1}_name`;
        const dobKey = i === 0 ? "child_dob" : `child${i + 1}_dob`;

        if (
            dependentForm[dobKey] &&
            dependentForm[nameKey] &&
            dependentForm[dobKey] !== existingDependents[dobKey]
        ) {
            dependents.push({ dob: dependentForm[dobKey] });
        }
    }

    // ✅ Parents
    if (allowedRelations.parents) {
        if (
            dependentForm.father_dob &&
            dependentForm.father_name &&
            dependentForm.father_dob !== existingDependents.father_dob
        ) {
            dependents.push({ dob: dependentForm.father_dob });
        }

        if (
            dependentForm.mother_dob &&
            dependentForm.mother_name &&
            dependentForm.mother_dob !== existingDependents.mother_dob
        ) {
            dependents.push({ dob: dependentForm.mother_dob });
        }
    }

    // ✅ In-laws
    if (allowedRelations.inlaws) {
        if (
            dependentForm.father_inlaw_dob &&
            dependentForm.father_inlaw_name &&
            dependentForm.father_inlaw_dob !== existingDependents.father_inlaw_dob
        ) {
            dependents.push({ dob: dependentForm.father_inlaw_dob });
        }

        if (
            dependentForm.mother_inlaw_dob &&
            dependentForm.mother_inlaw_name &&
            dependentForm.mother_inlaw_dob !== existingDependents.mother_inlaw_dob
        ) {
            dependents.push({ dob: dependentForm.mother_inlaw_dob });
        }
    }

    // 🚨 No new dependents
    if (dependents.length === 0) {
        return { premium: 0, gst: 0, total_premium: 0, total_sum_insured: 0 };
    }

    let annualPremiumTotal = 0;
    let totalSumInsured = 0;

    for (const dep of dependents) {
        const age = getAges(dep.dob);

        const res = await fetch(
            `/api/premium-rates?policy_id=${dependentForm.policy_id}&age=${age}`
        );

        const data = await res.json();

        console.log("🔥 API Response:", data);

        if (data?.total_premium) {
            annualPremiumTotal += Number(data.total_premium);
        }

        if (data?.total_sum_insured) {
            totalSumInsured = data.total_sum_insured; // same for all dependents
        }
    }

    const totalPolicyDays = diffInDays(
        dependentForm.policy_start_date,
        dependentForm.policy_end_date
    );

    const remainingDays = diffInDays(
        new Date(),
        dependentForm.policy_end_date
    );

    const prorationFactor =
        totalPolicyDays > 0 ? remainingDays / totalPolicyDays : 1;

    const proratedPremium = annualPremiumTotal * prorationFactor;
    const gstAmount = proratedPremium * ((dependentForm.gst || 18) / 100);

    return {
        premium: Math.round(proratedPremium),
        gst: Math.round(gstAmount),
        total_premium: Math.round(proratedPremium + gstAmount),
        total_sum_insured: totalSumInsured, // ✅ IMPORTANT
    };
};
    const handleUpdateDependent = async () => {
        try {
            // Only DB columns
            const payload = {
                emp_id: dependentForm.emp_id,
                spouse_name: dependentForm.spouse_name,
                spouse_dob: dependentForm.spouse_dob,
                child_name: dependentForm.child_name,
                child_dob: dependentForm.child_dob,
                child2_name: dependentForm.child2_name,
                child2_dob: dependentForm.child2_dob,
                child3_name: dependentForm.child3_name,
                child3_dob: dependentForm.child3_dob,
                father_name: dependentForm.father_name,
                father_dob: dependentForm.father_dob,
                mother_name: dependentForm.mother_name,
                mother_dob: dependentForm.mother_dob,
                father_inlaw_name: dependentForm.father_inlaw_name,
                father_inlaw_dob: dependentForm.father_inlaw_dob,
                mother_inlaw_name: dependentForm.mother_inlaw_name,
                mother_inlaw_dob: dependentForm.mother_inlaw_dob,
            };

            const res = await fetch("/api/employee/update-dependent", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });


            

            const text = await res.text();
            console.log("Raw response:", text);

            let data;
            try {
                data = JSON.parse(text);
            } catch (e) {
                console.error("Failed to parse JSON:", e);
                alert("Server returned invalid response. Check console.");
                return;
            }

            if (!res.ok || !data.success) {
                alert(data.message || "Failed to update dependent");
                return;
            }

            alert("Employee dependency updated successfully!");

            // Calculate premiums using frontend fields only
            const premiums = await calculateDependentPremium(dependentForm);

            // Update viewDependentData to open popup
            setViewDependentData({
                ...dependentForm,
                scheme_id: dependentForm.scheme_id,
                insurer: schemeInsurer,
                family_definition: schemeFamilyText,
                premium: premiums.premium,
                gst: premiums.gst,
                total_premium: premiums.total_premium,
                total_sum_insured: premiums.total_sum_insured,
            });

            setShowAddDependentPopup(false);

            setTimeout(() => {
                setShowViewDependentPopup(true);
            }, 50);

            fetchEmployees();

        } catch (err) {
            console.error("Error updating dependent:", err);
            alert("Something went wrong");
        }
    };


    // const handleSaveToEndorsement = async () => {
    //     try {
    //         if (!orgId) {
    //             alert("⚠️ No organization selected!");
    //             return;
    //         }

    //         const loggedUser = localStorage.getItem("username") || "ADMIN";

    //          let remarksList = [];

    //     const checkNewAddition = (oldVal, newVal, label) => {
    //         const wasEmpty = !oldVal || oldVal.trim() === "";
    //         const nowFilled = newVal && newVal.trim() !== "";

    //         if (wasEmpty && nowFilled) {
    //             remarksList.push(`${label} dependent added successfully`);
    //         }
    //     };

    //     checkNewAddition(existingDependentData?.spouse_name, viewDependentData?.spouse_name, "Spouse");
    //     checkNewAddition(existingDependentData?.child_name, viewDependentData?.child_name, "Child 1");
    //     checkNewAddition(existingDependentData?.child2_name, viewDependentData?.child2_name, "Child 2");
    //     checkNewAddition(existingDependentData?.child3_name, viewDependentData?.child3_name, "Child 3");
    //     checkNewAddition(existingDependentData?.father_name, viewDependentData?.father_name, "Father");
    //     checkNewAddition(existingDependentData?.mother_name, viewDependentData?.mother_name, "Mother");
    //     checkNewAddition(existingDependentData?.father_inlaw_name, viewDependentData?.father_inlaw_name, "Father-in-law");
    //     checkNewAddition(existingDependentData?.mother_inlaw_name, viewDependentData?.mother_inlaw_name, "Mother-in-law");

    //     const finalRemarks =
    //         remarksList.length > 0
    //             ? remarksList.join(", ")
    //             : "No new dependent added";

    //     // ======================================
    //     // 📦 PREPARE PAYLOAD
    //     // ======================================

    //     const payload = {
    //         ...viewDependentData,
    //         org_id: Number(orgId),
    //         status: "Pending",
    //         added_by: loggedUser,
    //         remarks: finalRemarks,
    //     };


    //         payload.spouse_name = payload.spouse_name || "";
    //         payload.spouse_dob = payload.spouse_dob || "";
    //         payload.child_name = payload.child_name || "";
    //         payload.child_dob = payload.child_dob || "";
    //         payload.child2_name = payload.child2_name || "";
    //         payload.child2_dob = payload.child2_dob || "";
    //         payload.child3_name = payload.child3_name || "";
    //         payload.child3_dob = payload.child3_dob || "";

    //         payload.father_name = payload.father_name || "";
    //         payload.father_dob = payload.father_dob || "";
    //         payload.mother_name = payload.mother_name || "";
    //         payload.mother_dob = payload.mother_dob || "";

    //         payload.father_inlaw_name = payload.father_inlaw_name || "";
    //         payload.father_inlaw_dob = payload.father_inlaw_dob || "";
    //         payload.mother_inlaw_name = payload.mother_inlaw_name || "";
    //         payload.mother_inlaw_dob = payload.mother_inlaw_dob || "";

    //         const res = await fetch(
    //             "/api/endorsement-track/newdependency",
    //             {
    //                 method: "POST",
    //                 headers: { "Content-Type": "application/json" },
    //                 body: JSON.stringify(payload),
    //             }
    //         );

    //         const data = await res.json();

    //         if (!res.ok || !data.success) {
    //             alert(data.message || "Failed to save endorsement");
    //             return;
    //         }

    //         alert("✅ Saved to endorsement successfully");
    //         setShowViewDependentPopup(false);

    //     } catch (err) {
    //         console.error(err);
    //         alert("❌ Something went wrong while saving endorsement");
    //     }
    // };
    
//    const handleAddAmount = async () => {
//     try {
//         if (!cdForm.amount || !cdPopupData.policy_id) {
//             alert("Please fill all fields");
//             return;
//         }

//         const cleanedAmount = cdForm.amount.replace(/,/g, "");

//         const res = await fetch("/api/cdBalance/add", {
//             method: "POST",
//             headers: { "Content-Type": "application/json" },
//             body: JSON.stringify({
//                 policy_id: cdPopupData.policy_id, // ✅ FIXED (NOT insurer_id)
//                 deposit_amount: Number(cleanedAmount),
//                 receipt_no: cdForm.receiptNo || null,
//                 cd_date: cdForm.date || null,
//                 modified_by: "System"
//             })
//         });

//         const data = await res.json();

//         if (!data.success) {
//             throw new Error(data.message);
//         }

//         alert(`✅ Amount added. New Balance: ${data.updatedRemaining}`);

//         setShowCdPopup(false);

//     } catch (err) {
//         console.error(err);
//         alert("Error adding amount");
//     }
// };
    
const handleAddAmount = async () => {
    try {
        const today = new Date().toISOString().split("T")[0];

        // ✅ Required fields check
        if (!cdForm.amount || !cdPopupData.policy_id || !cdForm.receiptNo || !cdForm.date) {
            alert("Please fill all fields");
            return;
        }

        // ✅ Date validation (only today allowed)
        if (cdForm.date !== today) {
            alert("Date must be today's date only");
            return;
        }

        // ✅ Receipt No validation (max 15 chars)
        if (cdForm.receiptNo.length > 15) {
            alert("Receipt No should not exceed 15 characters");
            return;
        }

        // 🔥 Optional strict (uncomment if needed)
        // if (cdForm.receiptNo.length !== 15) {
        //     alert("Receipt No must be exactly 15 characters");
        //     return;
        // }

        // ✅ Clean amount
        const cleanedAmount = cdForm.amount.replace(/,/g, "");

        if (Number(cleanedAmount) <= 0) {
            alert("Enter valid amount");
            return;
        }

        const res = await fetch("/api/cdBalance/add", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                policy_id: cdPopupData.policy_id,
                deposit_amount: Number(cleanedAmount),
                receipt_no: cdForm.receiptNo,
                cd_date: cdForm.date,
                modified_by: "System"
            })
        });

        const data = await res.json();

        if (!data.success) {
            throw new Error(data.message);
        }

        alert(`✅ Amount added. New Balance: ${data.updatedRemaining}`);

        setShowCdPopup(false);

    } catch (err) {
        console.error(err);
        alert("Error adding amount");
    }
};
 const handleSaveToEndorsement = async () => {
    try {
        if (!orgId) {
            alert("⚠️ No organization selected!");
            return;
        }

        if (!existingDependentData) {
            alert("⚠️ Existing dependent data not loaded properly.");
            return;
        }

        const loggedUser = localStorage.getItem("username") || "ADMIN";

        const normalize = (val) =>
            val === null || val === undefined ? "" : String(val).trim().toLowerCase();

        let remarksList = [];

        const checkNewAddition = (oldVal, newVal, label) => {
            const oldValue = normalize(oldVal);
            const newValue = normalize(newVal);

            if (oldValue === "" && newValue !== "") {
                remarksList.push(`${label} dependent added successfully`);
            }
        };

        // ✅ Compare
        checkNewAddition(existingDependentData.spouse_name, viewDependentData.spouse_name, "Spouse");
        checkNewAddition(existingDependentData.child_name, viewDependentData.child_name, "Child 1");
        checkNewAddition(existingDependentData.child2_name, viewDependentData.child2_name, "Child 2");
        checkNewAddition(existingDependentData.child3_name, viewDependentData.child3_name, "Child 3");
        checkNewAddition(existingDependentData.father_name, viewDependentData.father_name, "Father");
        checkNewAddition(existingDependentData.mother_name, viewDependentData.mother_name, "Mother");
        checkNewAddition(existingDependentData.father_inlaw_name, viewDependentData.father_inlaw_name, "Father-in-law");
        checkNewAddition(existingDependentData.mother_inlaw_name, viewDependentData.mother_inlaw_name, "Mother-in-law");

        const finalRemarks =
            remarksList.length > 0 ? remarksList.join("\n") : "No new dependent added";

        // ✅ 🔥 IMPORTANT FIX HERE
        const schemeIds = Array.isArray(viewDependentData.scheme_id)
            ? viewDependentData.scheme_id.join(",")   // convert array → "225,222"
            : String(viewDependentData.scheme_id);    // ensure string

        const payload = {
            ...viewDependentData,
            scheme_id: schemeIds, // ✅ FIXED
            org_id: Number(orgId),
            status: "Pending",
            added_by: loggedUser,
            remarks: finalRemarks,
        };

        console.log("🚀 Payload Sent:", payload); // 🔥 DEBUG

        const res = await fetch("/api/endorsement-track/newdependency", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
        });

        const data = await res.json();

        if (!res.ok || !data.success) {
            alert(data.message || "Failed to save endorsement");
            return;
        }

        alert(`✅ Saved to endorsement successfully:\n${finalRemarks}`);
        setShowViewDependentPopup(false);

    } catch (err) {
        console.error("Error saving endorsement:", err);
        alert("❌ Something went wrong while saving endorsement");
    }
};
    
    const findBasePremiumByAge = (age, rates) => {
        if (!Array.isArray(rates)) return 0;

        // Allow age 0–1 for newborns
        if (age < 0) return 0;

        for (const r of rates) {
            if (!r.age_range) continue;

            const [min, max] = r.age_range.split("-").map(Number);

            if (age >= min && age <= max) {
                return Number(r.base_premium || 0);
            }
        }

        return 0;
    };

    const addInsurerContact = () => {
        if (contacts.length < MAX_CONTACTS) {
            setContacts([...contacts, { contactName: "", contactEmail: "", attachment: null }]);
        }
    };

    // Update contact fields
    const updateInsurerContact = (index, field, value) => {
        const updated = [...contacts];
        updated[index][field] = value;
        setContacts(updated);
    };

    // Update file attachment
    const updateAttachment = (index, file) => {
        const updated = [...contacts];
        updated[index].attachment = file;
        setContacts(updated);
    };

    // Download Excel
    const downloadEmployeeExcel = () => {
        window.open("/api/download-emp-change-excel", "_blank");
    };

    function calculateFamilyPremium(emp, scheme, rates, joiningDate) {
        const round = (v) => Math.round(v * 100) / 100;
        const gstPercent = Number(scheme.gst || 18);

        let totalBase = 0;

        // -----------------------------
        // DATE HELPERS (FOR PRORATION)
        // -----------------------------
        const toDate = (d) => {
            if (!d) return null;
            const date = new Date(String(d).split("T")[0]);
            return isNaN(date.getTime()) ? null : date;
        };

        const calculateProrationFactor = () => {
            const policyStart = toDate(scheme.start_date);
            const policyEnd = toDate(scheme.end_date);
            const empJoin = toDate(joiningDate);

            // If policy dates missing → full premium
            if (!policyStart || !policyEnd) return 1;

            // Coverage starts from later of policy start OR employee joining
            const coverageStart =
                empJoin && empJoin > policyStart ? empJoin : policyStart;

            // Joined after policy ends → no premium
            if (coverageStart > policyEnd) return 0;

            const totalPolicyDays =
                (policyEnd - policyStart) / (1000 * 60 * 60 * 24) + 1;

            const coveredDays =
                (policyEnd - coverageStart) / (1000 * 60 * 60 * 24) + 1;

            return coveredDays / totalPolicyDays;
        };

        // -----------------------------
        // AGE & RATE HELPERS
        // -----------------------------
        const safeAge = (dobStr) => {
            if (!dobStr) return 0;
            const cleanDob = String(dobStr).trim();
            const dob = new Date(cleanDob);
            if (isNaN(dob.getTime())) return 0;
            const now = new Date();
            return Math.floor((now - dob) / (365.25 * 24 * 60 * 60 * 1000));
        };

        const baseForAge = (age) => {
            if (!Array.isArray(rates)) return 0;
            for (const r of rates) {
                if (!r.age_range) continue;
                const [min, max] = r.age_range.split("-").map(Number);
                if (age >= min && age <= max) {
                    return Number(r.base_premium || 0);
                }
            }
            return 0;
        };

        console.log("=== Employee Data ===");
        console.log(emp);

        // -----------------------------
        // EMPLOYEE
        // -----------------------------
        if (emp.dob) {
            const age = safeAge(emp.dob);
            const base = baseForAge(age);
            totalBase += base;
        }

        // -----------------------------
        // SPOUSE
        // -----------------------------
        if (scheme.family_spouse && emp.spouse_dob) {
            const age = safeAge(emp.spouse_dob);
            const base = baseForAge(age);
            totalBase += base;
        }

        // -----------------------------
        // CHILDREN
        // -----------------------------
        if (scheme.family_child) {
            const allowed = Math.max(1, Number(scheme.no_of_children || 3));

            const childDobs = [
                ...(emp.child_dob ? (Array.isArray(emp.child_dob) ? emp.child_dob : [emp.child_dob]) : []),
                ...(emp.child2_dob ? (Array.isArray(emp.child2_dob) ? emp.child2_dob : [emp.child2_dob]) : []),
                ...(emp.child3_dob ? (Array.isArray(emp.child3_dob) ? emp.child3_dob : [emp.child3_dob]) : [])
            ]
                .map(d => String(d).trim())
                .filter(Boolean);

            for (let i = 0; i < Math.min(childDobs.length, allowed); i++) {
                const age = safeAge(childDobs[i]);
                const base = baseForAge(age);
                totalBase += base;
            }
        }

        // -----------------------------
        // PARENTS
        // -----------------------------
        if (scheme.family_parents) {
            if (emp.father_dob) {
                totalBase += baseForAge(safeAge(emp.father_dob));
            }
            if (emp.mother_dob) {
                totalBase += baseForAge(safeAge(emp.mother_dob));
            }
        }

        // -----------------------------
        // IN-LAWS
        // -----------------------------
        if (scheme.family_inlaws) {
            if (emp.father_inlaw_dob) {
                totalBase += baseForAge(safeAge(emp.father_inlaw_dob));
            }
            if (emp.mother_inlaw_dob) {
                totalBase += baseForAge(safeAge(emp.mother_inlaw_dob));
            }
        }

        // -----------------------------
        // APPLY PRORATION
        // -----------------------------
        const prorationFactor = calculateProrationFactor();
        const proratedBase = round(totalBase * prorationFactor);
        const gst = round((proratedBase * gstPercent) / 100);

        console.log("Policy Start:", scheme.start_date);
        console.log("Policy End:", scheme.end_date);
        console.log("Joining Date:", joiningDate);
        console.log("Proration Factor:", prorationFactor);
        console.log("Final Base:", proratedBase);

        return {
            premium: proratedBase,
            gst,
            total_premium: round(proratedBase + gst)
        };
    }





    useEffect(() => {
        if (selectedTrack) {
            // Initialize with the employee email
            setEmails([selectedTrack.emp_email_id || ""]);
        }
    }, [selectedTrack]);


    const fetchEndorsementTrack = async (emp_id) => {
        try {
            const res = await fetch(
                `/api/endorsement-track/${emp_id}`
            );

            const data = await res.json();

            // ✅ ALWAYS force array
            setEndorsementTrack(Array.isArray(data) ? data : []);

        } catch (err) {
            console.error(err);
            // ✅ fail-safe
            setEndorsementTrack([]);
        }
    };


const handleCdAmountChange = (value) => {
    let cleaned = value.replace(/[^0-9.-]/g, "");

    const isNegative = cleaned.startsWith("-");
    cleaned = cleaned.replace(/-/g, "");
    if (isNegative) cleaned = "-" + cleaned;

    const parts = cleaned.split(".");
    if (parts.length > 2) {
        cleaned = parts[0] + "." + parts[1];
    }

    let [integer, decimal] = cleaned.split(".");
    let intPart = integer.replace("-", "");

    if (intPart) {
        const lastThree = intPart.slice(-3);
        const otherNumbers = intPart.slice(0, -3);

        if (otherNumbers !== "") {
            intPart =
                otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") +
                "," +
                lastThree;
        }
    }

    let formatted = decimal !== undefined ? `${intPart}.${decimal}` : intPart;

    if (isNegative) formatted = "-" + formatted;

    setCdForm({ ...cdForm, amount: formatted });
};



    const handleCategoryChange = (catId) => {
        setFilterCategory(catId);

        // 🔹 Update the formData with the selected category name
        const selectedCat = categories.find(
            (cat) => String(cat.cat_id) === String(catId)
        );

        setFormData((prev) => ({
            ...prev,
            cat_org_custom_name: selectedCat ? selectedCat.cat_org_custom_name : ""
        }));

        // 🔹 Filter schemes by category
        if (!catId) {
            setSchemeList(schemes); // show all schemes
            return;
        }

        const filteredSchemes = schemes.filter(
            (s) => s.cat_id?.toString() === catId.toString()
        );
        setSchemeList(filteredSchemes);
    };

    const handleDownload = () => {
        const link = document.createElement("a");
        link.href =
            process.env.PUBLIC_URL +
            "/Templates/blukuploadofemp/bulk-uploads of employee.xlsx";
        link.download = "Bulk Upload of Employee.xlsx";
        link.click();
    };

    // DELETE EMPLOYEE
    const handleDelete = async (empId) => {
        if (!window.confirm("Are you sure you want to delete this employee?")) return;
        try {
            const res = await fetch(`/api/employees/delete/${empId}`);
            const data = await res.json();
            if (data.success) {
                alert("Employee deleted successfully!");

            } else alert("Failed to delete employee");
        } catch (err) {
            console.error("Error deleting employee:", err);
        }
    };



    const calculateAge = (dob) => {
        if (!dob) return "";
        const birthDate = new Date(dob);
        const diffMs = Date.now() - birthDate.getTime();
        const ageDt = new Date(diffMs);
        return Math.abs(ageDt.getUTCFullYear() - 1970);
    };

    const parseDate = (val) => {
        if (!val) return null;

        // Case 1: Excel serial number
        if (!isNaN(val)) {
            const date = new Date((val - 25569) * 86400 * 1000);
            return date.toISOString().split("T")[0];
        }

        // Case 2: String date like "10-06-1988" or "20/10/2025"
        if (typeof val === "string") {
            let parts;
            if (val.includes("-")) parts = val.split("-");
            else if (val.includes("/")) parts = val.split("/");

            if (parts?.length === 3) {
                // detect dd-mm-yyyy or dd/mm/yyyy
                if (parts[2].length === 4) {
                    const [dd, mm, yyyy] = parts;
                    return `${yyyy}-${mm.padStart(2, "0")}-${dd.padStart(2, "0")}`;
                }
                // yyyy-mm-dd
                if (parts[0].length === 4) return val;
            }

            const d = new Date(val);
            return isNaN(d) ? null : d.toISOString().split("T")[0];
        }

        return null;
    };

    const loggedUser = localStorage.getItem("username") || "Unknown";

    const fetchSentEndorsements = async () => {
        if (!orgId) return;

        try {
            setLoading(true);

            const res = await fetch(`/api/endorsement-tracks?status=Pending&org_id=${orgId}`);
            const data = await res.json();

            console.log("Sent endorsements fetched:", data);
            setSentEndorsements(Array.isArray(data) ? data : []);
        } catch (error) {
            console.error("Error fetching sent endorsements:", error);
            setSentEndorsements([]); // fallback to empty array
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (showEndorsementPopup) {
            fetchSentEndorsements();
        }
    }, [showEndorsementPopup]);



    // const handleUpdateTrack = async (status) => {
    //     if (!selectedTrack) return;

    //     // 🔴 BLOCK APPROVAL WITHOUT ENDORSEMENT NUMBER
    //     if (status === "Approved" && !endorsementNumber.trim()) {
    //         alert("Endorsement Number is mandatory for approval");
    //         return;
    //     }

    //     const empId = selectedTrack.emp_id;
    //     const user = localStorage.getItem("username") || "Unknown";

    //     const totalSumInsured = selectedTrack.sum_insured_values
    //         ? selectedTrack.sum_insured_values.reduce((a, b) => a + b, 0)
    //         : 0;

    //     const filteredEmails = emails.map(e => e.trim()).filter(e => e);

    //     if (filteredEmails.length === 0) {
    //         alert("Please provide at least one email.");
    //         return;
    //     }

    //     try {
    //         const payload = {
    //             empId,
    //             endorsementNumber: endorsementNumber.trim(), // 🔐 always trimmed
    //             remarks,
    //             user,
    //             totalSumInsured,
    //             emails: filteredEmails,
    //         };

    //         const res = await fetch(
    //             status === "Approved"
    //                 ? "/api/endorsement/approve"
    //                 : "/api/endorsement/reject",
    //             {
    //                 method: "PUT",
    //                 headers: { "Content-Type": "application/json" },
    //                 body: JSON.stringify(payload),
    //             }
    //         );

    //         const data = await res.json();

    //         if (!data.success) {
    //             alert(data.error || "Something went wrong");
    //             return;
    //         }

    //         alert(
    //             status === "Approved"
    //                 ? "Endorsement Approved Successfully"
    //                 : "Endorsement Rejected Successfully"
    //         );

    //         setShowEditTrackPopup(false);
    //         fetchEndorsementTrack(selectedEmployee.emp_id);

    //     } catch (error) {
    //         console.error(error);
    //         alert("Server error");
    //     }
    // };


   const handleUpdateTrack = async (status) => {
    if (!selectedTrack) return;

    if (status === "Approved" && !endorsementNumber.trim()) {
        alert("Endorsement Number is mandatory for approval");
        return;
    }

    setLoadingAction(status); // 🔥 START LOADING

    const empId = selectedTrack.emp_id;
    const user = localStorage.getItem("username") || "Unknown";
    const orgId = Number(localStorage.getItem("org_id"));

    const totalSumInsured = selectedTrack.sum_insured_values
        ? selectedTrack.sum_insured_values.reduce((a, b) => a + b, 0)
        : 0;

    const filteredEmails = emails.map(e => e.trim()).filter(e => e);

    if (filteredEmails.length === 0) {
        alert("Please provide at least one email.");
        setLoadingAction(null); // 🔥 RESET
        return;
    }

    try {
        const payload = {
            empId,
            endorsementNumber: endorsementNumber.trim(),
            remarks,
            user,
            totalSumInsured,
            emails: filteredEmails,
            orgId
        };

        const res = await fetch(
            status === "Approved"
                ? "/api/endorsement/approve"
                : "/api/endorsement/reject",
            {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            }
        );

        const data = await res.json();

        if (!data.success) {
            alert(data.error || "Something went wrong");
            setLoadingAction(null);
            return;
        }

        alert(
            status === "Approved"
                ? "Endorsement Approved Successfully"
                : "Endorsement Rejected Successfully"
        );

        setShowEditTrackPopup(false);
        fetchEndorsementTrack(selectedEmployee.emp_id);

    } catch (error) {
        console.error(error);
        alert("Server error");
    } finally {
        setLoadingAction(null); // 🔥 STOP LOADING
    }
};
    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => {
            const updated = { ...prev, [name]: value };

            // Auto-calculate AGE when DOB changes
            if (name === "dob") {
                updated.age = calculateAge(value);
            }

            return updated;
        });
    };

    const detectCategoryField = (row) => {
        const possibleKeys = ["cat_org_custom_name", "cat_name", "categories", "category", "grade", "Cat", "Category"];
        for (const k of possibleKeys) {
            if (Object.prototype.hasOwnProperty.call(row, k)) return k;
        }
        return null;
    };

    const handleSave = async () => {
        const loggedUser = localStorage.getItem("username") || "Unknown";

        if (!orgId) {
            alert("⚠️ No organization selected!");
            return;
        }

        if (!formData.emp_id || !formData.emp_name || !formData.emp_email_id) {
            alert("⚠️ Please fill all required employee fields!");
            return;
        }

        if (!formData.cat_org_custom_name) {
            alert("⚠️ Category name is required!");
            return;
        }

        if (!formData.joining_date) {
            alert("⚠️ Joining Date is required!");
            return;
        }

        setIsSubmitting(true);

        // Flatten children safely
        const child1 = children[0] || {};
        const child2 = children[1] || {};
        const child3 = children[2] || {};

        const payload = {
            ...formData,
            org_id: Number(orgId),
            insured_name: formData.emp_name,
            edited_by: loggedUser,

            spouse_name: formData.spouse_name || "",
            spouse_dob: formData.spouse_dob || "",

            child_name: child1.name || "",
            child_dob: child1.dob || "",
            child2_name: child2.name || "",
            child2_dob: child2.dob || "",
            child3_name: child3.name || "",
            child3_dob: child3.dob || "",

            father_name: formData.father_name || "",
            father_dob: formData.father_dob || "",
            mother_name: formData.mother_name || "",
            mother_dob: formData.mother_dob || "",

            father_inlaw_name: formData.father_inlaw_name || "",
            father_inlaw_dob: formData.father_inlaw_dob || "",
            mother_inlaw_name: formData.mother_inlaw_name || "",
            mother_inlaw_dob: formData.mother_inlaw_dob || ""
        };

        // 🚫 IMPORTANT: do not update schemes during edit
        if (selectedEmployee) {
            delete payload.scheme_id;
        }

        try {
            let response;

            if (selectedEmployee) {
                // UPDATE
                response = await fetch(
                    `/api/employees/update/${payload.emp_id}`,
                    {
                        method: "PUT",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify(payload)
                    }
                );
            } else {
                // ADD
                response = await fetch(
                    "/api/employees/add-with-dependents",
                    {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify(payload)
                    }
                );
            }

            const result = await response.json();

            if (result.success) {
                alert(`✅ Employee ${selectedEmployee ? "updated" : "added"} successfully`);
setShowPopup(false);
                // ✅ Open scheme popup ONLY for ADD
                if (!selectedEmployee) {
                    setShowSchemeListPopup(true);
                }

                setSelectedEmployee(null);
            } else {
                alert("❌ Server error: " + result.message);
            }
        } catch (err) {
            console.error("Save error:", err);
            alert("❌ Error saving employee");
        } finally {
            setIsSubmitting(false);
        }
    };




    const handleResolveMappings = async () => {
        if (!orgId) {
            alert("Please save/select the organization first.");
            return;
        }

        setMappingLoading(true);

        try {
            // We'll process each mapping entry. If type === 'create' -> create category on server
            const newCategoriesCreated = [];

            const mappingEntries = Object.entries(categoryMappings); // [ [originalValue, mappingObj], ... ]

            for (const [originalValue, mappingObj] of mappingEntries) {
                if (mappingObj.type === "existing") {
                   
                    const existing = categoriesFromServer.find((c) => c.cat_id === mappingObj.cat_id);
                    if (existing) {
                        mappingObj.resolvedName = (existing.cat_org_custom_name && existing.cat_org_custom_name.trim()) || existing.cat_name;
                    } else {
                        mappingObj.resolvedName = mappingObj.cat_org_custom_name || originalValue;
                    }
                } else {
                    const payload = {
                        cat_name: originalValue,
                        cat_org_custom_name: mappingObj.new_custom_name || originalValue,
                        org_id: orgId,
                    };

                    const res = await fetch(`/api/organization/${orgId}/categories`, {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify(payload),
                    });

                    const created = await res.json();
                    if (res.ok && created && (created.category || created.data || created.success)) {
                        const returnedCat = created.category || created.data || created;
                        newCategoriesCreated.push(returnedCat);
                        mappingObj.resolvedName = returnedCat.cat_org_custom_name || returnedCat.cat_name || mappingObj.new_custom_name || originalValue;
                        mappingObj.cat_id = returnedCat.cat_id || returnedCat.id;
                    } else {
                        mappingObj.resolvedName = mappingObj.new_custom_name || originalValue;
                    }
                }
            }

            if (newCategoriesCreated.length === 0) {
                await fetchCategoriesByOrg(orgId);
            } else {
                setCategoriesFromServer((prev) => [...prev, ...newCategoriesCreated]);
            }

            const sampleRow = fileParsedEmployees[0] || {};
            const categoryField = detectCategoryField(sampleRow) || "categories";

            const updatedEmployees = fileParsedEmployees.map((row) => {
                const cellVal = (row[categoryField] || "").toString().trim();
                if (categoryMappings[cellVal]) {
                    return { ...row, cat_org_custom_name: categoryMappings[cellVal].resolvedName || categoryMappings[cellVal].new_custom_name || cellVal };
                }
                return { ...row, cat_org_custom_name: row[categoryField] || "" };
            });

            setEmployees(updatedEmployees);
            setShowCategoryMatchPopup(false);
            setFileParsedEmployees([]);
            setMismatchedCategories([]);
            setCategoryMappings({});
            alert("✅ Category mappings applied. You can now submit the employee data.");
        } catch (error) {
            console.error("Error resolving mappings:", error);
            alert("❌ Error while creating categories or applying mappings. See console.");
        } finally {
            setMappingLoading(false);
        }
    };


    const saveTrackUpdate = async (trackId, status, comment) => {
        try {
            const res = await fetch(
                `/api/employee-track/update/${trackId}`,
                {
                    method: "PUT",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ status, comment }),
                }
            );

            const data = await res.json();

            if (data.success) {
                alert("✅ Track updated successfully");
            } else {
                alert("❌ Failed to update track");
            }
        } catch (err) {
            console.error(err);
            alert("❌ Error while updating track");
        }
    };

    const formatLocalDate = (dateString) => {
        const d = new Date(dateString);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };

// const proceedSendMail = async () => {
//     try {
//         setLoading(true);

//         const insurers = Array.from(
//             new Map(selectedSchemes.map(s => [s.insurer, s])).values()
//         );

//         for (const insurer of insurers) {

//             const relatedSchemes = selectedSchemes.filter(
//                 s => s.insurer === insurer.insurer
//             );

//             const totalPremium = relatedSchemes.reduce(
//                 (sum, s) => sum + Number(s.employee?.total_premium || 0),
//                 0
//             );

//             const res = await fetch("/api/checkCdBalance", {
//                 method: "POST",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify({
//                     insurer: insurer.insurer,
//                     policy_id: relatedSchemes[0].policy_id
//                 })
//             });

//             const data = await res.json();
//             const balance = data.balance || 0;

//             if (totalPremium > balance) {
//                 setLoading(false);

//                 setCdPopupData({
//                     insurer: insurer.insurer,
//                     balance,
//                     required: totalPremium
//                 });

//                 setShowCdPopup(true);
//                 return; // 🚨 STOP FLOW
//             }

//             const payload = {
//                 insurer_name: insurer.insurer,
//                 insurer_email: insurer.insurer_email,
//                 org_id: insurer.org_id,

//                 schemes: relatedSchemes.map(s => ({
//                     scheme_id: s.scheme_id,
//                     policy_id: s.policy_id,
//                     policy_number: s.policy_number,
//                     scheme_name: s.scheme_name,
//                     sum_insured: s.sum_insured,
//                     insurer: s.insurer,
//                     premium: s.employee?.premium || 0,
//                     gst: s.employee?.gst || 0,
//                     total_premium: s.employee?.total_premium || 0
//                 })),

//                 employee: insurer.employee,
//                 user: localStorage.getItem("user_name")
//             };

//             await fetch("/api/sendMailToInsurer", {
//                 method: "POST",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify(payload)
//             });
//         }

//         alert("Mail(s) sent successfully!");
//         setShowMailPopup(false);
//         setSelectedSchemes([]);

//     } catch (err) {
//         alert("Error sending mail: " + err.message);
//     } finally {
//         setLoading(false);
//     }
// };


const proceedSendMail = async () => {
    try {
        setLoading(true);

        // ✅ GROUP BY POLICY (NOT INSURER)
        const policies = Array.from(
            new Map(selectedSchemes.map(s => [s.policy_id, s])).values()
        );

        for (const policy of policies) {

            const relatedSchemes = selectedSchemes.filter(
                s => s.policy_id === policy.policy_id
            );

            // ✅ TOTAL PREMIUM
            const totalPremium = relatedSchemes.reduce(
                (sum, s) => sum + Number(s.employee?.total_premium || 0),
                0
            );

            // ✅ CHECK CD BALANCE (ONLY POLICY)
            const res = await fetch("/api/checkCdBalance", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    policy_id: policy.policy_id   // ✅ FIXED
                })
            });

            const data = await res.json();
            const balance = data.balance || 0;

            // ❌ INSUFFICIENT BALANCE
            if (totalPremium > balance) {
                setLoading(false);

                setCdPopupData({
                    policy_id: policy.policy_id,   // ✅ IMPORTANT
                    insurer: policy.insurer,       // only for display
                    balance,
                    required: totalPremium
                });

                setShowCdPopup(true);
                return;
            }

            // ✅ SEND MAIL
            const payload = {
                insurer_id: policy.insurer_id,        // ✅ keep this
                insurer_name: policy.insurer,
                insurer_email: policy.insurer_email,
                org_id: policy.org_id,

                schemes: relatedSchemes.map(s => ({
                    scheme_id: s.scheme_id,
                    policy_id: s.policy_id,
                    policy_number: s.policy_number,
                    scheme_name: s.scheme_name,
                    sum_insured: s.sum_insured,
                    premium: s.employee?.premium || 0,
                    gst: s.employee?.gst || 0,
                    total_premium: s.employee?.total_premium || 0,
                    insurer: s.insurer 
                })),

                employee: policy.employee,
                user: localStorage.getItem("user_name")
            };

            await fetch("/api/sendMailToInsurer", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload)
            });
        }

        alert("Mail(s) sent successfully!");
        setShowMailPopup(false);
        setSelectedSchemes([]);

    } catch (err) {
        console.error(err);
        alert("Error sending mail: " + err.message);
    } finally {
        setLoading(false);
    }
};
    return (
        <div className="dashboard-main">
            <aside className="sidebar">
                <Header />
            </aside>
            <div className="dashboard-card">
                <h2 className="dashboard-title">Employee Management</h2>


                {/* Scheme Dropdown */}
                <div className="scheme-filter">
                    {/* Left side: Search and Filter */}
                    <div className="scheme-left">
                        <input
                            type="text"
                            placeholder="Search by name or employee ID"
                            className="search-input"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />

                        <div className="filter-container">
                            <FaFilter className="filter-icon" />
                            <select
                                value={filterCategory}
                                onChange={(e) => handleCategoryChange(e.target.value)}
                                className="filter-dropdown"
                            >
                                <option value="">All Categories</option>
                                {Array.isArray(categories) &&
                                    categories.map((cat, index) => (
                                        <option key={index} value={cat.cat_id}>
                                            {cat.cat_org_custom_name}
                                        </option>
                                    ))
                                }
                            </select>
                        </div>

                    </div>

                    {/* Right side: Buttons */}
                    <div className="scheme-right">
                        <button
                            className="primary-btn"
                            onClick={() => setShowPopup(true)}

                        >
                            <FaPlus /> Add Employee
                        </button>

                        {/* <button
                            className="primary-btn"
                            onClick={() => setShowPanel(true)}
                        >
                            Send Insurer Notification
                        </button> */}
                       <button
    className="primary-btn"
    onClick={() => setShowEndorsementPopup(true)}
>
    View Pending Addition Emp List
</button>
                   <button
className="primary-btn"
onClick={() => {
    setShowDeactiveEmployeePopup(true);
    fetchPendingEmployees();
}}
>
View Pending Deletion Emp list
</button>
                    </div>

                </div>

                {/* Employee Table */}
                <div className="employee-table-container">
                    {loading ? (
                        <p>Loading employees...</p>
                    ) : filteredEmployees.length === 0 ? (
                        <p>No employees found.</p>
                    ) : (
                        <>
                            <table className="employee-table">
                                <thead>
                                    <tr>
                                        <th>Emp ID</th>
                                        <th>Scheme Name</th>
                                        <th>Name</th>
                                        <th>Categories</th>
                                        <th>Email</th>
                                        <th>Designation</th>
                                        <th>Phone</th>
                                        <th>DOB</th>
                                        <th>Sum Insured</th>
                                        <th>Total Premium</th>
                                        <th>Status</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentEmployees.map((emp) => (
                                        <tr key={emp.id}>
                                            <td>{emp.emp_id}</td>
                                            <td>{emp.scheme_name}</td>
                                            <td>{emp.emp_name}</td>
                                            <td>{emp.cat_org_custom_name}</td>
                                            <td>{emp.emp_email_id}</td>
                                            <td>{emp.designation}</td>
                                            <td>{emp.phone_number}</td>
                                            <td>{emp.dob ? emp.dob.split("T")[0] : ""}</td>
                                            <td>{emp.sum_insured}</td>
                                            <td>{emp.total_premium}</td>
                                            <td
    style={{
        color: emp.emp_status === "Inactive" ? "red" : "green",
        fontWeight: "bold"
    }}
>
    {emp.emp_status}
</td>
                                            <td>
                                                {isNoSchemeList && (
                                                    <button
                                                        className="add-scheme-btn"
                                                        onClick={() => {
                                                            setSelectedEmployee(emp);
                                                            setShowSchemePopup(true);
                                                        }}
                                                    >
                                                        Add Scheme
                                                    </button>
                                                )}
                                                <FaEdit
                                                    className="icon edit-icon"
                                                    title="Edit"
                                                    onClick={() => {
                                                        setSelectedEmployee(emp);
                                                        setOriginalEmployee(emp);

                                                        // -------- CHILDREN --------
                                                        const childrenArr = buildChildrenFromEmployee(emp);
                                                        setChildren(childrenArr);
                                                        setChildCountInput(childrenArr.length);

                                                        // -------- FORM DATA --------
                                                        setFormData({
                                                            emp_id: emp.emp_id,
                                                            emp_name: emp.emp_name,
                                                            joining_date: emp.joining_date ? emp.joining_date.split("T")[0] : "",
                                                            designation: emp.designation || "",
                                                            phone_number: emp.phone_number || "",
                                                            emp_email_id: emp.emp_email_id || "",
                                                            gender: emp.gender || "",
                                                            dob: emp.dob ? emp.dob.split("T")[0] : "",
                                                            age: emp.age || "",
                                                            emp_status: emp.emp_status || "Active",
                                                            last_working_date: emp.last_working_date
                                                                ? emp.last_working_date.split("T")[0]
                                                                : "",
                                                            sum_insured: emp.sum_insured || 0,
                                                            cat_id: emp.cat_id,
                                                            cat_org_custom_name: emp.cat_org_custom_name || "",

                                                            // -------- SPOUSE --------
                                                            spouse_name: emp.spouse_name || "",
                                                            spouse_dob: emp.spouse_dob ? emp.spouse_dob.split("T")[0] : "",

                                                            // -------- PARENTS --------
                                                            father_name: emp.father_name || "",
                                                            father_dob: emp.father_dob ? emp.father_dob.split("T")[0] : "",
                                                            mother_name: emp.mother_name || "",
                                                            mother_dob: emp.mother_dob ? emp.mother_dob.split("T")[0] : "",

                                                            // -------- IN-LAWS --------
                                                            father_inlaw_name: emp.father_inlaw_name || "",
                                                            father_inlaw_dob: emp.father_inlaw_dob
                                                                ? emp.father_inlaw_dob.split("T")[0]
                                                                : "",
                                                            mother_inlaw_name: emp.mother_inlaw_name || "",
                                                            mother_inlaw_dob: emp.mother_inlaw_dob
                                                                ? emp.mother_inlaw_dob.split("T")[0]
                                                                : "",

                                                            children: childrenArr
                                                        });

                                                        setFilterCategory(emp.cat_id?.toString() || "");

                                                        // -------- AUTO OPEN CORRECT TAB --------
                                                        if (emp.spouse_name) setActiveTab("spouse");
                                                        else if (childrenArr.length > 0) setActiveTab("child");
                                                        else if (emp.father_name || emp.mother_name) setActiveTab("parents");
                                                        else if (emp.father_inlaw_name || emp.mother_inlaw_name)
                                                            setActiveTab("inlaws");

                                                        setShowPopup(true);
                                                    }}
                                                />


                                                &nbsp;&nbsp;
                                                <button
                                                    className="view-endorsement-btn"
                                                    onClick={async () => {
                                                        const storedUser = JSON.parse(localStorage.getItem("user"));

                                                        if (!storedUser?.org_id) {
                                                            alert("Organization not found!");
                                                            return;
                                                        }

                                                        setSelectedEmployee(emp);
                                                        setLoadingTrack(true);
                                                        setShowEndorsementTrackPopup(true);

                                                        try {
                                                            const res = await fetch(
                                                                `/api/endorsement-track/${emp.emp_id}?org_id=${storedUser.org_id}`
                                                            );

                                                            const data = await res.json();
                                                            setEndorsementTrack(data);
                                                        } catch (err) {
                                                            console.error("Error fetching endorsement track:", err);
                                                            setEndorsementTrack([]);
                                                        } finally {
                                                            setLoadingTrack(false);
                                                        }
                                                    }}
                                                >
                                                    View Endorsement Track
                                                </button>
                                                &nbsp;&nbsp;
                                                {emp.emp_status !== "Inactive" && (
                                                    <FaTrash
                                                        className="icon delete-icon"
                                                        title="Deactivate"
                                                        onClick={async () => {
                                                            try {
                                                                // Fetch employee schemes
                                                                const res = await fetch(`/api/employee-scheme/${emp.emp_id}`);

                                                                if (!res.ok) {
                                                                    throw new Error("Failed to fetch scheme");
                                                                }

                                                                const schemes = await res.json();

                                                                // Check if employee has no schemes or scheme_id is missing/null
                                                                if (
                                                                    !schemes || // null or undefined
                                                                    (Array.isArray(schemes) && schemes.length === 0) || // empty array
                                                                    (Array.isArray(schemes) && !schemes[0]?.scheme_id) || // first item has no scheme_id
                                                                    (!Array.isArray(schemes) && !schemes.scheme_id) // single object with no scheme_id
                                                                ) {
                                                                    alert("This employee does not belong to any scheme. Cannot delete this record.");
                                                                    return;
                                                                }

                                                                // Employee has a valid scheme → proceed
                                                                const schemeToUse = Array.isArray(schemes) ? schemes[0] : schemes;

                                                                setSelectedEmployee(emp);
                                                                setSelectedEmployeeScheme(schemeToUse);
                                                                setShowDeactivatePopup(true);

                                                            } catch (err) {
                                                                console.error("Error checking employee scheme:", err);
                                                                alert("Something went wrong while checking the scheme");
                                                            }
                                                        }}
                                                    />


                                                )}
                                               <button
    className={`add-dependent-btn ${
        emp.emp_status === "Inactive" || !emp.scheme_id ? "disabled-btn" : ""
    }`}
    disabled={emp.emp_status === "Inactive" || !emp.scheme_id}
    title={
        emp.emp_status === "Inactive"
            ? "Employee is inactive. Cannot add dependents."
            : !emp.scheme_id
            ? "Employee should be in a scheme."
            : "Add Dependent"
    }
    onClick={async () => {
        if (emp.emp_status === "Inactive" || !emp.scheme_id) return; // extra safety

        setSelectedEmployee(emp);

        try {
            const res = await fetch(
                `/api/employee-scheme/${emp.emp_id}`
            );
            const data = await res.json();

            const schemeData = Array.isArray(data) ? data[0] : data;

            // ✅ Allowed relations
            const familyDefinition = {
                spouse: schemeData.family_spouse === true,
                children: schemeData.family_child
                    ? Number(schemeData.no_of_children || 0)
                    : 0,
                parents: schemeData.family_parents === true,
                inlaws: schemeData.family_inlaws === true,
            };

            setAllowedRelations(familyDefinition);
            setSchemeInsurer(schemeData.insurer || "");

            let familyText = "";
            if (schemeData.family_spouse) familyText += "Spouse ";
            if (schemeData.family_child)
                familyText += `Child (${schemeData.no_of_children}) `;
            if (schemeData.family_parents) familyText += "Parents ";
            if (schemeData.family_inlaws) familyText += "In-Laws ";

            setSchemeFamilyText(familyText.trim());

            const initialDependentForm = {
                emp_id: emp.emp_id || "",
                emp_name: emp.emp_name || "",
                scheme_id: emp.scheme_id || "",

                spouse_name: emp.spouse_name || "",
                spouse_dob: formatDateForInput(emp.spouse_dob),

                child_name: emp.child_name || "",
                child_dob: formatDateForInput(emp.child_dob),

                child2_name: emp.child2_name || "",
                child2_dob: formatDateForInput(emp.child2_dob),

                child3_name: emp.child3_name || "",
                child3_dob: formatDateForInput(emp.child3_dob),

                father_name: emp.father_name || "",
                father_dob: formatDateForInput(emp.father_dob),

                mother_name: emp.mother_name || "",
                mother_dob: formatDateForInput(emp.mother_dob),

                father_inlaw_name: emp.father_inlaw_name || "",
                father_inlaw_dob: formatDateForInput(emp.father_inlaw_dob),

                mother_inlaw_name: emp.mother_inlaw_name || "",
                mother_inlaw_dob: formatDateForInput(emp.mother_inlaw_dob),

                policy_start_date: schemeData.start_date
                    ? formatDateForInput(schemeData.start_date)
                    : "",
                policy_end_date: schemeData.end_date
                    ? formatDateForInput(schemeData.end_date)
                    : "",

                sum_insured: schemeData.sum_insured || 0,
                policy_id: schemeData.policy_id,
                gst: schemeData.gst_percent,
            };

            setDependentForm(initialDependentForm);

            setExistingDependents({
                spouse_dob: initialDependentForm.spouse_dob || "",
                child_dob: initialDependentForm.child_dob || "",
                child2_dob: initialDependentForm.child2_dob || "",
                child3_dob: initialDependentForm.child3_dob || "",
                father_dob: initialDependentForm.father_dob || "",
                mother_dob: initialDependentForm.mother_dob || "",
                father_inlaw_dob: initialDependentForm.father_inlaw_dob || "",
                mother_inlaw_dob: initialDependentForm.mother_inlaw_dob || "",
            });

            setShowAddDependentPopup(true);
        } catch (err) {
            console.error("Error fetching scheme family definition", err);
            alert("Unable to load scheme family definition");
        }
    }}
>
    {emp.emp_status === "Inactive" || !emp.scheme_id
        ? "🚫 Add Dependent"
        : "Add Dependent"}
</button>



                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                            {/* Pagination Controls */}
                            <div className="pagination">
                                <button onClick={handlePrev} disabled={currentPage === 1}>
                                    Prev
                                </button>

                                {getVisiblePages().map((page) => (
                                    <button
                                        key={page}
                                        className={currentPage === page ? "active" : ""}
                                        onClick={() => handlePageClick(page)}
                                    >
                                        {page}
                                    </button>
                                ))}

                                <button onClick={handleNext} disabled={currentPage === totalPages}>
                                    Next
                                </button>
                            </div>
                        </>
                    )}
                </div>



            </div>
            {showPopup && (
                <div className="employeemanpopup-overlay">
                    <div className="employeemanpopup-card">
                        <h3>Add Employee</h3>

                        {/* Updated form with onSubmit */}
                        <form
                            className="employeemanform-grid"
                            onSubmit={(e) => {
                                e.preventDefault(); // Prevent page refresh
                                handleSave();       // Call your save function
                            }}
                        >
                            {/* Organization ID */}
                            <div className="employeemanform-group">
                                <label>Organization ID</label>
                                <input type="text" value={orgId || ""} readOnly />
                            </div>

                            {/* Category Select */}
                            <div className="employeemanform-group">
                                <label>Category</label>
                                <select
                                    value={filterCategory}
                                    onChange={(e) => {
                                        const catId = e.target.value;
                                        setFilterCategory(catId);

                                        const selectedCat = categories.find(
                                            (c) => c.cat_id.toString() === catId
                                        );

                                        setFormData((prev) => ({
                                            ...prev,
                                            cat_id: selectedCat ? selectedCat.cat_id : "",
                                            cat_name: selectedCat ? selectedCat.cat_name : "",
                                            cat_org_custom_name: selectedCat
                                                ? selectedCat.cat_org_custom_name || selectedCat.cat_name
                                                : prev.cat_org_custom_name || "",
                                        }));
                                    }}
                                    className="filter-dropdown"
                                >
                                    <option value="">All Categories</option>
                                    {Array.isArray(categories) &&
                                        categories.map((cat) => (
                                            <option key={cat.cat_id} value={cat.cat_id}>
                                                {cat.cat_org_custom_name || cat.cat_name}
                                            </option>
                                        ))}
                                </select>

                            </div>

                            <div className="employeemanform-group">
                                <label>Employee ID</label>

                                <input
                                    type="text"
                                    name="emp_id"
                                    value={formData.emp_id || ""}
                                    maxLength={10}
                                    onChange={(e) => {
                                        // allow only alphanumeric
                                        const value = e.target.value.replace(/[^a-zA-Z0-9]/g, "");

                                        // update state ALWAYS (so typing works)
                                        setFormData({ ...formData, emp_id: value });

                                        // 🔥 LIVE validation
                                        if (!value) {
                                            setEmpIdError("Employee ID is required");
                                        }
                                        else if (/^[A-Za-z]+$/.test(value)) {
                                            // ❌ ONLY alphabets
                                            setEmpIdError("Employee ID cannot be only alphabets");
                                        }
                                        else {
                                            // ✅ numbers-only OR alphanumeric
                                            setEmpIdError("");
                                        }
                                    }}
                                    className={empIdError ? "input-error" : ""}
                                />

                                {empIdError && <span className="error-text">{empIdError}</span>}
                            </div>

                            <div className="employeemanform-group">
                                <label>Name</label>
                                <input
                                    type="text"
                                    name="emp_name"
                                    value={formData.emp_name || ""}
                                    onChange={handleChange}
                                    required
                                    pattern="^[A-Za-z ]+$"
                                    onInput={(e) => {
                                        e.target.value = e.target.value.replace(/[^A-Za-z ]/g, ""); // only letters + space
                                    }}
                                    title="Name can contain only alphabets"
                                />
                            </div>

                            <div className="employeemanform-group">
                                <label>Email</label>
                                <input
                                    type="email"
                                    name="emp_email_id"
                                    value={formData.emp_email_id || ""}
                                    onChange={handleChange}
                                    required
                                    pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
                                    title="Please enter a valid email address"
                                />
                            </div>

                            <div className="employeemanform-group">
                                <label>Joining Date</label>
                                <input
                                    type="date"
                                    name="joining_date"
                                    value={formData.joining_date || ""}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="employeemanform-group">
                                <label>Designation</label>
                                <input
                                    type="text"
                                    name="designation"
                                    value={formData.designation || ""}
                                    onChange={handleChange}
                                    maxLength={20}
                                    title="Maximum 20 characters allowed"
                                />
                            </div>

                            <div className="employeemanform-group">
                                <label>Phone</label>
                                <input
                                    type="text"
                                    name="phone_number"
                                    value={formData.phone_number || ""}
                                    onChange={handleChange}
                                    maxLength={10}
                                    pattern="\d{10}"
                                    onInput={(e) => {
                                        e.target.value = e.target.value.replace(/\D/g, ""); // only numbers
                                    }}
                                    required
                                />
                            </div>

                            <div className="employeemanform-group">
                                <label>Gender</label>
                                <select name="gender" value={formData.gender || ""} onChange={handleChange}>
                                    <option value="">Select</option>
                                    <option value="Male">Male</option>
                                    <option value="Female">Female</option>
                                    <option value="Other">Other</option>
                                </select>
                            </div>
                            <div className="employeemanform-group">
                                <label>DOB</label>

                                <input
                                    type="date"
                                    name="dob"
                                    value={formData.dob || ""}
                                    max={new Date().toISOString().split("T")[0]}
                                    onChange={(e) => {
                                        const selectedDate = e.target.value;
                                        const today = new Date();

                                        if (!selectedDate) {
                                            setFormData({ ...formData, dob: "", age: "" });
                                            setDobError("");
                                            return;
                                        }

                                        const dobDate = new Date(selectedDate);

                                        // ❌ Future date check
                                        if (dobDate > today) {
                                            setDobError("DOB cannot be a future date");
                                            return;
                                        }

                                        // ✅ Age calculation
                                        let age = today.getFullYear() - dobDate.getFullYear();
                                        const monthDiff = today.getMonth() - dobDate.getMonth();

                                        if (
                                            monthDiff < 0 ||
                                            (monthDiff === 0 && today.getDate() < dobDate.getDate())
                                        ) {
                                            age--;
                                        }

                                        setDobError("");

                                        setFormData({
                                            ...formData,
                                            dob: selectedDate,
                                            age: age >= 0 ? age : 0
                                        });
                                    }}
                                    className={dobError ? "input-error" : ""}
                                />

                                {dobError && <span className="error-text">{dobError}</span>}
                            </div>

                            <div className="employeemanform-group">
                                <label>Age</label>
                                <input
                                    type="number"
                                    name="age"
                                    value={formData.age || ""}
                                    readOnly
                                />
                            </div>

                            <div className="employeemanform-group">
                                <label>Status</label>

                                <select
                                    name="emp_status"
                                    value={formData.emp_status || "Active"}
                                    onChange={handleChange}
                                >
                                    <option value="Active">Active</option>

                                    {/* Disabled option */}
                                    <option value="Inactive" disabled>
                                        Inactive
                                    </option>
                                </select>
                            </div>
                            <hr />

                            {/* Dependents Section */}
                            <div className="relationship-section">
                                <div className="relationship-buttons">
                                    {["spouse", "child", "parents", "inlaws"].map((tab) => (
                                        <button
                                            type="button"
                                            key={tab}
                                            className={`relationship-btn ${activeTab === tab ? "active" : ""}`}
                                            onClick={() => setActiveTab(tab)}
                                        >
                                            {tab.charAt(0).toUpperCase() + tab.slice(1)}
                                        </button>
                                    ))}
                                </div>

                                <div className="relationship-fields">
                                    {activeTab === "spouse" && (
                                        <>

                                            {/* SPOUSE NAME */}
                                            <input
                                                type="text"
                                                name="spouse_name"
                                                placeholder="Spouse Name"
                                                value={formData.spouse_name || ""}
                                                onChange={handleChange}
                                            />

                                            {/* SPOUSE DOB */}
                                            <label htmlFor="spouse_dob">DOB</label>
                                            <input
                                                type="date"
                                                id="spouse_dob"
                                                name="spouse_dob"
                                                value={formData.spouse_dob || ""}
                                                onChange={handleChange}
                                                max={new Date().toISOString().split("T")[0]}
                                            />

                                        </>
                                    )}

                                    {activeTab === "child" && (
                                        <>

                                            {/* HIDE THIS SECTION IN EDIT MODE */}
                                            {!isEditMode && (
                                                <>
                                                    <label>No. of Children (Max 3)</label>

                                                    <input
                                                        type="number"
                                                        min="1"
                                                        max="3"
                                                        value={childCountInput}
                                                        onChange={(e) => {
                                                            let val = e.target.value;

                                                            if (val === "") {
                                                                setChildCountInput("");
                                                                setChildren([]);
                                                                return;
                                                            }

                                                            let count = Number(val);
                                                            if (count < 1) count = 1;
                                                            if (count > 3) count = 3;

                                                            setChildCountInput(count);

                                                            const updated = Array.from({ length: count }, (_, i) => ({
                                                                name: children[i]?.name || "",
                                                                dob: children[i]?.dob || ""
                                                            }));

                                                            setChildren(updated);

                                                            setFormData((prev) => ({
                                                                ...prev,
                                                                children: updated
                                                            }));
                                                        }}
                                                    />
                                                </>
                                            )}

                                            {/* THIS WILL SHOW CHILD NAME & DOB IN EDIT MODE */}
                                            {children.map((child, index) => (
                                                <div key={index} className="child-field-group">

                                                    <input
                                                        type="text"
                                                        placeholder={`Child ${index + 1} Name`}
                                                        value={child.name}
                                                        onChange={(e) => {
                                                            const updated = [...children];
                                                            updated[index].name = e.target.value;

                                                            setChildren(updated);
                                                            setFormData((prev) => ({
                                                                ...prev,
                                                                children: updated
                                                            }));
                                                        }}
                                                    />

                                                    <label>DOB</label>
                                                    <input
                                                        type="date"
                                                        value={child.dob}
                                                        onChange={(e) => {
                                                            const updated = [...children];
                                                            updated[index].dob = e.target.value;

                                                            setChildren(updated);
                                                            setFormData((prev) => ({
                                                                ...prev,
                                                                children: updated

                                                            }));

                                                        }}
                                                        max={new Date().toISOString().split("T")[0]}
                                                    />
                                                </div>
                                            ))}

                                        </>
                                    )}






                                    {activeTab === "parents" && (
                                        <>
                                            {/* Father */}
                                            <input
                                                type="text"
                                                name="father_name"
                                                placeholder="Father Name"
                                                value={formData.father_name || ""}
                                                onChange={handleChange}
                                            />
                                            <label>DOB</label>
                                            <input
                                                type="date"
                                                name="father_dob"
                                                placeholder="Father DOB"
                                                value={formData.father_dob || ""}
                                                onChange={handleChange}
                                                max={new Date().toISOString().split("T")[0]}
                                            />

                                            {/* Mother */}
                                            <input
                                                type="text"
                                                name="mother_name"
                                                placeholder="Mother Name"
                                                value={formData.mother_name || ""}
                                                onChange={handleChange}
                                            />
                                            <label>DOB</label>
                                            <input
                                                type="date"
                                                name="mother_dob"
                                                placeholder="Mother DOB"
                                                value={formData.mother_dob || ""}
                                                onChange={handleChange}
                                                max={new Date().toISOString().split("T")[0]}
                                            />
                                        </>
                                    )}

                                    {activeTab === "inlaws" && (
                                        <>
                                            {/* Father-in-law */}
                                            <input
                                                type="text"
                                                name="father_inlaw_name"
                                                placeholder="Father-in-law Name"
                                                value={formData.father_inlaw_name || ""}
                                                onChange={handleChange}
                                            />
                                            <label>DOB</label>
                                            <input
                                                type="date"
                                                name="father_inlaw_dob"
                                                placeholder="Father-in-law DOB"
                                                value={formData.father_inlaw_dob || ""}
                                                onChange={handleChange}
                                                max={new Date().toISOString().split("T")[0]}
                                            />

                                            {/* Mother-in-law */}
                                            <input
                                                type="text"
                                                name="mother_inlaw_name"
                                                placeholder="Mother-in-law Name"
                                                value={formData.mother_inlaw_name || ""}
                                                onChange={handleChange}
                                            />
                                            <label>DOB</label>
                                            <input
                                                type="date"
                                                name="mother_inlaw_dob"
                                                placeholder="Mother-in-law DOB"
                                                value={formData.mother_inlaw_dob || ""}
                                                onChange={handleChange}
                                                max={new Date().toISOString().split("T")[0]}
                                            />
                                        </>
                                    )}

                                </div>
                            </div>

                            {/* Action Buttons */}
                            <div className="employeemanpopup-actions">
                                <button type="submit" disabled={isSubmitting}>
                                    {isSubmitting ? "Saving..." : "Save"}
                                </button>
                                <button type="button" onClick={() => setShowPopup(false)}>
                                    Cancel
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}


            {showSchemePopup && (
                <div className="employeemanagement-popup-overlay">
                    <div className="employeemanagement-popup-box">
                        <h3>Confirmation</h3>
                        <p>Do you need to add this employee to the scheme?</p>
                        <div className="employeemanagement-popup-actions">
                            <button
                                className="addscheme-btn-yes"
                                onClick={() => {
                                    setShowSchemePopup(false);
                                    setShowSchemeListPopup(true);

                                }}
                            >
                                Yes
                            </button>

                            <button
                                className="addscheme-btn-no"
                                onClick={() => {
                                    setShowSchemePopup(false); // ✅ Close popup
                                }}
                            >
                                No
                            </button>
                        </div>
                    </div>
                </div>

            )}

            {showSchemeListPopup && (
                <div className="addscheme-list-popups">
                    <div className="addscheme-list-content">
                        <div className="popup-close-icon" onClick={() => setShowSchemeListPopup(false)}>
                            <FaTimes />
                        </div>

                        <h3>Select Scheme(s) for Selected Category</h3>

                        <div className="addscheme-selected-category">
                            <label>Selected Category:</label>
                            <p>{formData.cat_org_custom_name || "No Category Selected"}</p>
                        </div>

                        {loadingSchemes ? (
                            <p>Loading schemes...</p>
                        ) : (
                            <table className="addscheme-table">
                                <thead>
                                    <tr>
                                        <th></th>
                                       
                                        <th>Policy ID</th>
                                        <th>Category Name</th>
                                        <th>Scheme Name</th>
                                        <th>Start date</th>
                                        <th>End date</th>
                                        <th>Sum Insured</th>
                                        <th>Policy No</th>
                                        <th>Insurer</th>
                                        
                                        <th>Family Definitions</th>
                                        <th>Premium</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {schemeList.length > 0 ? (
                                        schemeList.map((scheme) => (
                                            <tr key={scheme.scheme_id}>
                                                <td>
                                                    <input
                                                        type="checkbox"
                                                        checked={selectedSchemes.some(s => s.scheme_id === scheme.scheme_id)}
                                                        onChange={async () => {
                                                            try {
                                                                const res = await fetch(
                                                                    `/api/premiumRates/AddEmp?policy_id=${scheme.policy_id}&sum_insured=${scheme.sum_insured}`
                                                                );
                                                                const premiumRates = await res.json();

                                                                // Prepare child arrays
                                                                const children = formData.children || [];
                                                                const childDobs = children.map(c => c.dob).filter(Boolean);
                                                                const childNames = children.map(c => c.name);

                                                                // Calculate premium
                                                                const premiumData = calculateFamilyPremium(
                                                                    {
                                                                        ...formData,
                                                                        child_dob: childDobs[0] ? [childDobs[0]] : [],
                                                                        child2_dob: childDobs[1] ? [childDobs[1]] : [],
                                                                        child3_dob: childDobs[2] ? [childDobs[2]] : [],
                                                                        child_name: childNames[0] || "",
                                                                        child2_name: childNames[1] || "",
                                                                        child3_name: childNames[2] || "",
                                                                    },
                                                                    scheme,
                                                                    premiumRates,
                                                                    formData.joining_date,
                                                                    scheme.end_date
                                                                );

                                                                setSelectedSchemes(prev => {
                                                                    const exists = prev.find(s => s.scheme_id === scheme.scheme_id);
                                                                    if (exists) {
                                                                        return prev.filter(s => s.scheme_id !== scheme.scheme_id);
                                                                    } else {
                                                                        return [
                                                                            ...prev,
                                                                            {
                                                                                ...scheme,
                                                                                employee: {
                                                                                    ...formData,
                                                                                    children,
                                                                                    child_dob: childDobs[0] ? [childDobs[0]] : [],
                                                                                    child2_dob: childDobs[1] ? [childDobs[1]] : [],
                                                                                    child3_dob: childDobs[2] ? [childDobs[2]] : [],
                                                                                    child_name: childNames[0] || "",
                                                                                    child2_name: childNames[1] || "",
                                                                                    child3_name: childNames[2] || "",
                                                                                    premium: premiumData.premium,
                                                                                    gst: premiumData.gst,
                                                                                    total_premium: premiumData.total_premium
                                                                                }
                                                                            }
                                                                        ];
                                                                    }
                                                                });

                                                                setFormData(prev => {
                                                                    const ids = prev.scheme_id || [];
                                                                    if (ids.includes(scheme.scheme_id)) {
                                                                        return { ...prev, scheme_id: ids.filter(id => id !== scheme.scheme_id) };
                                                                    } else {
                                                                        return { ...prev, scheme_id: [...ids, scheme.scheme_id] };
                                                                    }
                                                                });
                                                            } catch (error) {
                                                                console.error("Error calculating premium:", error);
                                                            }
                                                        }}
                                                    />
                                                </td>

                                               
                                                <td>{scheme.policy_id}</td>
                                                <td>{scheme.cat_org_custom_name}</td>
                                                <td>{scheme.scheme_name ? scheme.scheme_name.split("(")[0].trim() : ""}</td>
                                                <td>{scheme.start_date ? scheme.start_date.split("T")[0] : ""}</td>
                                                <td>{scheme.end_date ? scheme.end_date.split("T")[0] : ""}</td>
                                                <td>{scheme.sum_insured}</td>
                                                <td>{scheme.policy_number}</td>
                                                <td>{scheme.insurer}</td>
                                               
                                                <td>
                                                    {scheme.family_spouse ? "Spouse " : ""}
                                                    {scheme.family_child ? `Child (${scheme.no_of_children}) ` : ""}
                                                    {scheme.family_parents ? "Parents " : ""}
                                                    {scheme.family_inlaws ? "In-Laws" : ""}
                                                </td>
                                                <td>{scheme.premium}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="13" style={{ textAlign: "center" }}>
                                                No schemes found for this category.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        )}

                        <div style={{ marginTop: "15px", textAlign: "right" }}>
                            <button
                                className="save-button"
                                type="button"
                                disabled={!formData.scheme_id || formData.scheme_id.length === 0}
                                onClick={() => {
                                    if (!formData.scheme_id || formData.scheme_id.length === 0) {
                                        alert("Please select at least one scheme before saving.");
                                        return;
                                    }
                                    setShowSchemeListPopup(false);
                                    setShowEmployeeSchemePopup(true);
                                }}
                            >
                                Save Selected Schemes
                            </button>
                        </div>
                    </div>
                </div>
            )}



            {showEmployeeSchemePopup && (
                <div className="scheme-emp-overlay">
                    <div className="scheme-emp-popup">
                        <button
                            className="scheme-emp-close-btn"
                            onClick={() => setShowEmployeeSchemePopup(false)}
                        >
                            Close
                        </button>

                        <h3 className="scheme-emp-title">Selected Schemes for Employee</h3>

                        {/* --------------------------- */}
                        {/* INDIVIDUAL SCHEME BREAKDOWN */}
                        {/* --------------------------- */}
                        <h4>Selected Schemes Breakdown</h4>

                        <div className="scheme-emp-table-wrapper">
                            <table className="scheme-emp-table">
                                <thead>
                                    <tr>
                                        <th>Scheme ID</th>
                                        <th>Sum Insured (Premium)</th>
                                        <th>Premium</th>
                                        <th>GST</th>
                                        <th>Total Premium</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {selectedSchemes.map(s => (
                                        <tr key={s.scheme_id}>
                                            <td>{s.scheme_id}</td>
                                            <td>{s.sum_insured} ({s.employee.premium})</td>
                                            <td>{s.employee.premium}</td>
                                            <td>{s.employee.gst}</td>
                                            <td>{s.employee.total_premium}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        <br />

                        {/* --------------------------- */}
                        {/* GROUPED EMPLOYEE SUMMARY */}
                        {/* --------------------------- */}
                        <div className="scheme-emp-table-wrapper">
                            <table className="scheme-emp-table">
                                <thead>
                                    <tr>
                                        <th>Org ID</th>
                                        <th>Scheme IDs</th>
                                        <th>Sum Insured (Combined)</th>
                                        <th>Policy No.</th>
                                        <th>EMP ID</th>
                                        <th>Name</th>
                                        <th>Email</th>
                                        <th>Designation</th>
                                        <th>joining_date</th>
                                        <th>DOB</th>
                                        <th>Age</th>
                                        <th>Spouse</th>
                                        <th>Spouse DOB</th>
                                        <th>Child Name(s)</th>
                                        <th>Child DOB(s)</th>
                                        <th>Parent Name(s)</th>
                                        <th>Parent DOB(s)</th>
                                        <th>In Laws(s)</th>
                                        <th>In Laws DOB(s)</th>
                                        <th>Total Premium</th>
                                        <th>Total GST</th>
                                        <th>Grand Total</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {Object.values(
                                        selectedSchemes.reduce((acc, s) => {
                                            const empId = s.employee.emp_id;
                                            if (!acc[empId]) {
                                                acc[empId] = {
                                                    ...s.employee,
                                                    org_id: s.org_id,
                                                    scheme_ids: [s.scheme_id],
                                                    policy_ids: [s.policy_id],
                                                    sum_insured: [`${s.sum_insured} (${s.employee.premium})`],
                                                    premium: Number(s.employee.premium || 0),
                                                    gst: Number(s.employee.gst || 0),
                                                    total_premium: Number(s.employee.total_premium || 0)
                                                };
                                            } else {
                                                acc[empId].scheme_ids.push(s.scheme_id);
                                                acc[empId].policy_ids.push(s.policy_id);
                                                acc[empId].sum_insured.push(`${s.sum_insured} (${s.employee.premium})`);
                                                acc[empId].premium += Number(s.employee.premium || 0);
                                                acc[empId].gst += Number(s.employee.gst || 0);
                                                acc[empId].total_premium += Number(s.employee.total_premium || 0);
                                            }
                                            return acc;
                                        }, {})
                                    ).map((emp) => {

                                        // ---------------------------
                                        // Children (same logic as your first popup)
                                        // ---------------------------
                                        // Children
                                        const childDobs = Array.isArray(emp.child_dob)
                                            ? emp.child_dob
                                            : emp.child_dob
                                                ? [emp.child_dob]
                                                : [];

                                        const childNames = childDobs.map((_, i) => {
                                            if (i === 0) return emp.child_name || "";
                                            if (i === 1) return emp.child2_name || "";
                                            if (i === 2) return emp.child3_name || "";
                                            return "";
                                        });

                                        // --- Parents ---
                                        const parentNames = [emp.father_name, emp.mother_name].filter(Boolean);
                                        const parentDobs = [emp.father_dob, emp.mother_dob]
                                            .filter(Boolean)
                                            .map((d) => (typeof d === "string" ? d.split("T")[0] : d));

                                        // --- In-Laws ---
                                        const inlawNames = [emp.father_inlaw_name, emp.mother_inlaw_name].filter(Boolean);
                                        const inlawDobs = [emp.father_inlaw_dob, emp.mother_inlaw_dob]
                                            .filter(Boolean)
                                            .map((d) => (typeof d === "string" ? d.split("T")[0] : d));

                                        return (
                                            <tr key={emp.emp_id}>
                                                <td>{emp.org_id}</td>
                                                <td>{emp.scheme_ids.join(", ")}</td>
                                                <td>{emp.sum_insured.join(", ")}</td>
                                                <td>{emp.policy_ids.join(", ")}</td>
                                                <td>{emp.emp_id}</td>
                                                <td>{emp.emp_name}</td>
                                                <td>{emp.emp_email_id}</td>
                                                <td>{emp.designation}</td>
                                                <td>{emp.joining_date}</td>
                                                <td>{emp.dob ? emp.dob.split("T")[0] : ""}</td>
                                                <td>{emp.age}</td>

                                                {/* Spouse */}
                                                <td>{emp.spouse_name || "-"}</td>
                                                <td>{emp.spouse_dob ? emp.spouse_dob.split("T")[0] : "-"}</td>

                                                {/* Children */}
                                                <td>
                                                    {children.length > 0
                                                        ? children.map((c, idx) => <div key={idx}>{c.name}</div>)
                                                        : "-"}
                                                </td>

                                                <td>
                                                    {children.length > 0
                                                        ? children.map((c, idx) => <div key={idx}>{c.dob ? c.dob.split("T")[0] : ""}</div>)
                                                        : "-"}
                                                </td>

                                                {/* Parents */}
                                                <td>{parentNames.join(", ")}</td>
                                                <td>{parentDobs.join(", ")}</td>

                                                {/* In-Laws */}
                                                <td>{inlawNames.join(", ")}</td>
                                                <td>{inlawDobs.join(", ")}</td>

                                                <td>{emp.premium}</td>
                                                <td>{emp.gst}</td>
                                                <td>{emp.total_premium}</td>
                                            </tr>
                                        );
                                    })}
                                </tbody>

                            </table>
                        </div>

                        <div style={{ marginTop: "20px", textAlign: "right" }}>
                            <button
                                className="btn-send"
                                onClick={() => {
                                    setShowEmployeeSchemePopup(false);
                                    setShowMailPopup(true);
                                }}
                            >
                                Send Mail
                            </button>
                        </div>

                        <div style={{ marginTop: "20px", textAlign: "left" }}>
                            <button
                                className="btn-back"
                                onClick={() => {
                                    setShowEmployeeSchemePopup(false);
                                    setShowSchemeListPopup(true);
                                }}
                            >
                                ← Back
                            </button>
                        </div>
                    </div>
                </div>
            )}




            {showMailPopup && selectedSchemes.length > 0 && (
                <div className="mail-overlay">
                    <div className="mail-box">
                        <h3>Send Mail to Insurer</h3>
                        <p>Send notification email to the insurer with new employee details.</p>

                        <div className="mail-form">
                            {/* Unique insurers */}
                            {Array.from(new Map(selectedSchemes.map(s => [s.insurer, s])).values())
                                .map((scheme, index) => (
                                    <div key={index} className="insurer-field-group">
                                        <label>Insurer {index + 1}</label>
                                        <input type="text" value={scheme.insurer || ""} readOnly />

                                        <label>Insurer Email {index + 1}</label>
                                        <input
                                            type="email"
                                            value={scheme.insurer_email || ""}
                                            onChange={(e) => {
                                                const newEmail = e.target.value;
                                                setSelectedSchemes(prev =>
                                                    prev.map(s =>
                                                        s.insurer === scheme.insurer
                                                            ? { ...s, insurer_email: newEmail }
                                                            : s
                                                    )
                                                );
                                            }}
                                            placeholder="Enter email"
                                        />
                                    </div>
                                ))}
                        </div>

                     <div className="mail-actions">
    <button
        className="btn-send"
        disabled={loading}
        onClick={proceedSendMail}
    >
        {loading ? "Sending..." : "Send"}
    </button>

    <button
        className="btn-cancel"
        onClick={() => setShowMailPopup(false)}
    >
        Cancel
    </button>
</div>
                    </div>
                </div>
            )}

            {showDeactivatePopup && selectedEmployee && (
                <div className="deactivepopup-overlay">
                    <div className="deactivepopup">
                        <h3>Deactivate Employee</h3>

                        <p>
                            Are you sure you want to deactivate <strong>{selectedEmployee.emp_name}</strong> (ID: <strong>{selectedEmployee.emp_id}</strong>)?
                        </p>

                        <p>
                            Scheme: <strong>{selectedEmployeeScheme?.scheme_name || "N/A"}</strong><br />
                            Insurer: <strong>{selectedEmployeeScheme?.insurer || "N/A"}</strong><br />
                            Policy Start Date:
                            <strong>
                                {selectedEmployeeScheme?.start_date
                                    ? new Date(selectedEmployeeScheme.start_date).toLocaleDateString()
                                    : "-"}
                            </strong><br />
                            Policy End Date:
                            <strong>
                                {selectedEmployeeScheme?.end_date
                                    ? new Date(selectedEmployeeScheme.end_date).toLocaleDateString()
                                    : "-"}
                            </strong><br />

                            Total Premium: <strong>{selectedEmployeeScheme?.total_premium}</strong><br />
GST: <strong>{selectedEmployeeScheme?.gst}</strong><br />
Premium: <strong>{selectedEmployeeScheme?.premium}</strong>
                        </p>



                        <label>
                            Last Working Date:
                            <input
                                type="date"
                                id="lastWorkingDate"
                                min={formatLocalDate(selectedEmployeeScheme?.start_date)}
                                max={formatLocalDate(selectedEmployeeScheme?.end_date)}
                                defaultValue={formatLocalDate(selectedEmployeeScheme?.start_date)}
                                onChange={(e) => {
                                    const lastDate = new Date(e.target.value);
                                    const startDate = new Date(selectedEmployeeScheme.start_date);
                                    const endDate = new Date(selectedEmployeeScheme.end_date);

                                    const totalDays = (endDate - startDate) / (1000 * 60 * 60 * 24) + 1;
                                    const usedDays = (lastDate - startDate) / (1000 * 60 * 60 * 24) + 1;

                                    const totalPremium = Number(selectedEmployee.total_premium);
                                    const remaining = ((totalDays - usedDays) / totalDays) * totalPremium;

                                    document.getElementById("remainingPremium").value = remaining.toFixed(2);
                                }}
                            />


                        </label>

                        <label>
                            Remaining Premium:
                            <input
                                type="text"
                                id="remainingPremium"
                                value={selectedEmployee.total_premium}
                                readOnly
                            />
                        </label>

                        <div className="deactivepopup-actions">
                           <button
    onClick={async () => {
        if (!selectedEmployeeScheme) {
            alert("⚠️ No scheme selected for this employee.");
            return;
        }

        const lastWorkingDate = document.getElementById("lastWorkingDate").value;

        if (!lastWorkingDate) {
            alert("⚠️ Please select last working date.");
            return;
        }

        // ✅ Calculate remaining premium
        const startDate = new Date(selectedEmployeeScheme.start_date);
        const endDate = new Date(selectedEmployeeScheme.end_date);
        const lastDate = new Date(lastWorkingDate);

        const totalDays = (endDate - startDate) / (1000 * 60 * 60 * 24) + 1;
        const usedDays = (lastDate - startDate) / (1000 * 60 * 60 * 24) + 1;

        const totalPremium = Number(selectedEmployeeScheme.total_premium || 0);
        const remainingPremium =
            ((totalDays - usedDays) / totalDays) * totalPremium;

        try {
            const res = await fetch(
                "/api/employees/deactivate",
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        emp_id: selectedEmployee.emp_id,
                        scheme_id: selectedEmployeeScheme.scheme_id,
                        last_working_date: lastWorkingDate,
                        remaining_premium: remainingPremium.toFixed(2),
                    }),
                }
            );

            const data = await res.json();

            if (data.success) {
                // ✅ Store details for email popup
                setInsurerDetails({
                    insurer: selectedEmployeeScheme.insurer,
                    emp_name: selectedEmployee.emp_name,
                    emp_id: selectedEmployee.emp_id,
                    last_working_date: lastWorkingDate,
                    remainingPremium: data.remainingPremium,
                    updatedRemaining: data.updatedRemaining,
                });

                // ✅ Close first popup
                setShowDeactivatePopup(false);

                // ✅ Open email popup
                setShowEmailPopup(true);

            } else {
                alert(`❌ Failed: ${data.message}`);
            }

        } catch (err) {
            console.error("Error deactivating employee:", err);
            alert("❌ Something went wrong. Check console for details.");
        }
    }}
    className="deactivebutton confirm"
>
    Deactivate
</button>
                            <button
                                onClick={() => setShowDeactivatePopup(false)}
                                className="deactivebutton cancel"
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {showEmailPopup && insurerDetails && (
                <div className="deactivepopup-overlay">
                    <div className="deactivepopup">
                        <h3>Send Email to Insurer</h3>

                        <p>
                            <strong>Insurer:</strong> {insurerDetails.insurer}
                        </p>

                        <p>
                            <strong>Employee:</strong> {insurerDetails.emp_name}
                            (ID: {insurerDetails.emp_id})
                        </p>

                        <p>
                            <strong>Last Working Date:</strong> {insurerDetails.last_working_date}
                        </p>

                        <p>
                            <strong>Remaining Premium Added:</strong> ₹ {insurerDetails.remainingPremium}
                        </p>
                        <label>
                            Enter Email:
                            <input
                                type="email"
                                value={emailToSend}
                                onChange={(e) => setEmailToSend(e.target.value)}
                                placeholder="Enter insurer email"
                                style={{ width: "100%", padding: "6px", marginTop: "5px" }}
                            />
                        </label>

                        <div className="deactivepopup-actions">
                            <button
    className="deactivebutton confirm"
    disabled={isSending}
    onClick={async () => {
        if (!emailToSend) {
            alert("⚠️ Please enter email address.");
            return;
        }

        setIsSending(true); // start loading

        try {
            const res = await fetch(
                "/api/send-deactivation-mail",
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        email: emailToSend,
                        details: insurerDetails
                    }),
                }
            );

            const data = await res.json();

            if (data.success) {
                alert("✅ Email sent successfully!");

                setShowEmailPopup(false);
                setEmailToSend("");
                setInsurerDetails(null);
                setSelectedEmployee(null);
                setSelectedEmployeeScheme(null);
            } else {
                alert("❌ Failed to send email.");
            }

        } catch (err) {
            console.error("Email error:", err);
            alert("❌ Something went wrong while sending email.");
        } finally {
            setIsSending(false); // stop loading
        }
    }}
>
    {isSending ? "Sending..." : "Send"}
</button>

                            <button
                                className="deactivebutton cancel"
                                onClick={() => setShowEmailPopup(false)}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {showNoSchemePopup && (
                <div className="no-scheme-popup-overlay">
                    <div className="no-scheme-popup-content">

                        <h3>No Schemes Found</h3>
                        <p>
                            There are no schemes under the selected category
                            <b> "{formData.cat_org_custom_name}"</b>.
                        </p>
                        <p>Do you want to create a new scheme?</p>

                        <div className="no-scheme-popup-buttons">
                            <button
                                className="yes-btn"
                                onClick={() => {
                                    setShowNoSchemePopup(false);
                                    navigate("/initial-setup");   // 🔥 navigate to scheme creation
                                }}
                            >
                                Yes, Create Now
                            </button>

                            <button
                                className="no-btn"
                                onClick={() => {
                                    setShowNoSchemePopup(false);
                                }}
                            >
                                No, Go Back
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {showEndorsementTrackPopup && (
                <div className="endorsement-popup-overlay">
                    <div className="endorsement-popup-container">
                        <button
                            className="popup-close"
                            onClick={() => setShowEndorsementTrackPopup(false)}
                        >
                            ×
                        </button>

                        <h3 className="popup-title">
                            Endorsement Track for {selectedEmployee?.emp_name}
                        </h3>

                        {loadingTrack ? (
                            <p>Loading...</p>
                        ) : endorsementTrack.length > 0 ? (
                            <>
                                {/* --------------------------- */}
                                {/* INDIVIDUAL SCHEME BREAKDOWN */}
                                {/* --------------------------- */}
                                <h4>Individual Scheme Premiums</h4>
                                <div className="scheme-emp-table-wrapper">
                                    <table className="scheme-emp-table">
                                        <thead>
                                            <tr>
                                                <th>Scheme Name</th>
                                                <th>Sum Insured (Premium)</th>
                                                <th>Premium</th>
                                                <th>GST</th>
                                                <th>Total Premium</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {endorsementTrack.map((s) => (
                                                <tr key={s.scheme_id}>
                                                    <td>{s.scheme_name}</td>
                                                    <td>{s.sum_insured} ({s.premium})</td>
                                                    <td>{s.premium}</td>
                                                    <td>{s.gst}</td>
                                                    <td>{s.total_premium}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>

                                <br />

                                {/* --------------------------- */}
                                {/* GROUPED EMPLOYEE SUMMARY */}
                                {/* --------------------------- */}
                                <div className="scheme-emp-table-wrapper">
                                    <table className="scheme-emp-table">
                                        <thead>
                                            <tr>
                                                <th>Scheme Name</th>
                                                <th>Policy No.</th>
                                                <th>Emp ID</th>
                                                <th>Name</th>
                                                <th>Email</th>
                                                <th>Designation</th>
                                                <th>DOB</th>
                                                <th>Spouse</th>
                                                <th>Spouse DOB</th>
                                                {showChild && <th>Child</th>}
                                                {showChildDob && <th>DOB</th>}

                                                {showChild2 && <th>2nd Child</th>}
                                                {showChild2Dob && <th>DOB</th>}

                                                {showChild3 && <th>3rd Child</th>}
                                                {showChild3Dob && <th>DOB</th>}

                                                {showMother && <th>Mother</th>}
                                                {showMotherDob && <th>DOB</th>}

                                                {showFather && <th>Father</th>}
                                                {showFatherDob && <th>DOB</th>}

                                                {showMotherInLaw && <th>Mother In-Law</th>}
                                                {showMotherInLawDob && <th>DOB</th>}

                                                {showFatherInLaw && <th>Father In-Law</th>}
                                                {showFatherInLawDob && <th>DOB</th>}
                                                <th>Total Sum Insured</th>
                                                <th>Premium</th>
                                                <th>GST</th>
                                                <th>Total Premium</th>
                                                <th>Endorsements</th>
                                                <th>Status</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {Object.values(
                                                endorsementTrack.reduce((acc, row) => {
                                                    const id = row.emp_id;

                                                    if (!acc[id]) {
                                                        acc[id] = {
                                                            ...row,
                                                            scheme_ids: [row.scheme_name],
                                                            policy_ids: [row.policy_id],
                                                            sum_insured_values: [Number(row.sum_insured || 0)], // store numeric value
                                                            endorsement_numbers: [row.endorsement_number],
                                                            premium: Number(row.premium || 0),
                                                            gst: Number(row.gst || 0),
                                                            total_premium: Number(row.total_premium || 0),
                                                        };
                                                    } else {
                                                        acc[id].scheme_ids.push(row.scheme_name);
                                                        acc[id].policy_ids.push(row.policy_id);
                                                        acc[id].sum_insured_values.push(Number(row.sum_insured || 0));
                                                        acc[id].endorsement_numbers.push(row.endorsement_number);
                                                        acc[id].premium += Number(row.premium || 0);
                                                        acc[id].gst += Number(row.gst || 0);
                                                        acc[id].total_premium += Number(row.total_premium || 0);
                                                    }

                                                    return acc;
                                                }, {})
                                            ).map((emp) => {
                                                const totalSumInsured = emp.sum_insured_values.reduce((a, b) => a + b, 0);

                                                return (
                                                    <tr key={emp.emp_id}>
                                                        <td>{[...new Set(emp.scheme_ids)].join(", ")}</td>
                                                        <td>{[...new Set(emp.policy_ids)].join(", ")}</td>
                                                        <td>{emp.emp_id}</td>
                                                        <td>{emp.emp_name}</td>
                                                        <td>{emp.emp_email_id}</td>
                                                        <td>{emp.designation}</td>
                                                        <td>{emp.dob}</td>
                                                        <td>{emp.spouse_name}</td>
                                                        <td>{emp.spouse_dob}</td>
                                                        {showChild && <td>{emp.child || "-"}</td>}
                                                        {showChildDob && <td>{emp.child_dob || "-"}</td>}

                                                        {showChild2 && <td>{emp.child2_name || "-"}</td>}
                                                        {showChild2Dob && <td>{emp.child2_dob || "-"}</td>}

                                                        {showChild3 && <td>{emp.child3_name || "-"}</td>}
                                                        {showChild3Dob && <td>{emp.child3_dob || "-"}</td>}

                                                        {showMother && <td>{emp.mother_name || "-"}</td>}
                                                        {showMotherDob && <td>{emp.mother_dob || "-"}</td>}

                                                        {showFather && <td>{emp.father_name || "-"}</td>}
                                                        {showFatherDob && <td>{emp.father_dob || "-"}</td>}

                                                        {showMotherInLaw && <td>{emp.mother_inlaw_name || "-"}</td>}
                                                        {showMotherInLawDob && <td>{emp.mother_inlaw_dob || "-"}</td>}

                                                        {showFatherInLaw && <td>{emp.father_inlaw_name || "-"}</td>}
                                                        {showFatherInLawDob && <td>{emp.father_inlaw_dob || "-"}</td>}

                                                        <td>{totalSumInsured}</td> {/* ✅ Total sum insured */}
                                                        <td>{emp.premium}</td>
                                                        <td>{emp.gst}</td>
                                                        <td>{emp.total_premium}</td>
                                                        <td>{emp.endorsement_numbers.join(", ")}</td>
                                                        <td>{emp.status}</td>
                                                        <td>
                                                            <FaEdit
                                                                className="icon-edit"
                                                                title="Edit Endorsement"
                                                                onClick={() => {
                                                                    setSelectedTrack({
                                                                        ...emp,
                                                                        scheme_ids: emp.scheme_ids,
                                                                        policy_ids: emp.policy_ids,
                                                                    });
                                                                    setEmails([emp.emp_email_id]);
                                                                    setEndorsementNumber(emp.endorsement_numbers.join(", "));
                                                                    setRemarks(emp.remarks || "");
                                                                    setShowEditTrackPopup(true);
                                                                }}
                                                            />
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </>
                        ) : (
                            <p>No endorsement records found.</p>
                        )}
                    </div>
                </div>
            )}

            {showEditTrackPopup && selectedTrack && (
                <div className="track-popup-overlay">
                    <div className="track-popup-card">
                        {/* Close Button */}
                        <button
                            className="track-popup-close"
                            onClick={() => setShowEditTrackPopup(false)}
                        >
                            ×
                        </button>

                        <h3 className="track-popup-title">Edit Endorsement</h3>

                        {/* Scheme IDs */}
                        <div className="track-popup-field">
                            <label>Scheme Name:</label>
                            <input
                                type="text"
                                value={
                                    selectedTrack.scheme_ids
                                        ? [...new Set(selectedTrack.scheme_ids)].join(", ")
                                        : ""
                                }
                                readOnly
                            />
                        </div>

                        {/* Policy IDs */}
                        <div className="track-popup-field">
                            <label>Policy No.:</label>
                            <input
                                type="text"
                                value={
                                    selectedTrack.policy_ids
                                        ? selectedTrack.policy_ids.map(p => p.number || p).join(", ")
                                        : ""
                                }
                                readOnly
                            />
                        </div>

                        {/* Total Sum Insured */}
                        <div className="track-popup-field">
                            <label>Total Sum Insured:</label>
                            <input
                                type="text"
                                value={
                                    selectedTrack.sum_insured_values
                                        ? selectedTrack.sum_insured_values.reduce((a, b) => a + b, 0)
                                        : 0
                                }
                                readOnly
                            />
                        </div>

                        {/* Endorsement Number */}
                        <div className="track-popup-field">
                            <label>
                                Endorsement Number <span className="track-required">*</span>
                            </label>
                            <input
                                type="text"
                                value={endorsementNumber}
                                onChange={(e) => setEndorsementNumber(e.target.value)}
                                maxLength={20}
                            />
                        </div>

                        {/* Emails */}
                        {emails.map((email, index) => (
                            <div className="track-popup-field track-email-field" key={index}>
                                <label>Email {index + 1}:</label>
                                <input
                                    type="email"
                                    value={email}
                                    onChange={(e) => {
                                        const updatedEmails = [...emails];
                                        updatedEmails[index] = e.target.value;
                                        setEmails(updatedEmails);
                                    }}
                                    placeholder="Enter email"
                                />
                                <div className="track-email-buttons">
                                    {emails.length < 5 && index === emails.length - 1 && (
                                        <button
                                            type="button"
                                            onClick={() => setEmails([...emails, ""])}
                                            className="track-btn-add"
                                        >
                                            + Add
                                        </button>
                                    )}
                                    {emails.length > 1 && (
                                        <button
                                            type="button"
                                            onClick={() => setEmails(emails.filter((_, i) => i !== index))}
                                            className="track-btn-remove"
                                        >
                                            - Remove
                                        </button>
                                    )}
                                </div>
                            </div>
                        ))}

                        {/* Remarks */}
                        <div className="track-popup-field">
                            <label>Remarks:</label>
                            <textarea
                                value={remarks}
                                onChange={(e) => setRemarks(e.target.value)}
                            />
                        </div>

                        {/* Approve / Reject */}
                        <div className="track-popup-actions">
                            <button
    className="track-btn-approve"
    onClick={() => handleUpdateTrack("Approved")}
    disabled={loadingAction !== null}
>
    {loadingAction === "Approved" ? "Approving..." : "Approve"}
</button>

<button
    className="track-btn-reject"
    onClick={() => handleUpdateTrack("Rejected")}
    disabled={loadingAction !== null}
>
    {loadingAction === "Rejected" ? "Rejecting..." : "Reject"}
</button>
                        </div>
                    </div>
                </div>
            )}

            {showAddDependentPopup && (
                <div className="add-dependent-overlay">
                    <div className="add-dependent-modal">

                        <h3 className="add-dependent-title">Add Dependent</h3>
                       

                        {/* ================= Employee Info ================= */}
                        <div className="add-dependent-section">
                            <div className="add-dependent-section-title">Employee Info</div>

                            <div className="add-dependent-row">
                                <div className="add-dependent-field">
                                    <label>Employee ID</label>
                                    <input type="text" value={dependentForm.emp_id} disabled />
                                </div>

                                <div className="add-dependent-field">
                                    <label>Employee Name</label>
                                    <input type="text" value={dependentForm.emp_name} disabled />
                                </div>
                            </div>

                            <div className="add-dependent-row three-col">
                                <div className="add-dependent-field">
                                    <label>Scheme ID</label>
                                    <input type="text" value={dependentForm.scheme_id} disabled />
                                </div>

                                <div className="add-dependent-field">
                                    <label>Insurer</label>
                                    <input type="text" value={schemeInsurer} disabled />
                                </div>

                                <div className="add-dependent-field">
                                    <label>Family Definition</label>
                                    <input type="text" value={schemeFamilyText} disabled />
                                </div>
                            </div>
                            <div className="add-dependent-row three-col">
                                <div className="add-dependent-field">
                                    <label>Policy Start Date</label>
                                    <input type="date" value={dependentForm.policy_start_date} disabled />
                                </div>

                                <div className="add-dependent-field">
                                    <label>Policy End Date</label>
                                    <input type="date" value={dependentForm.policy_end_date} disabled />
                                </div>
                                <div className="add-dependent-field">
                                    <label>Sum Insured</label>
                                    <input type="text" value={dependentForm.sum_insured} disabled />
                                </div>
                                <div className="add-dependent-field">
                                    <label>policy_id</label>
                                    <input type="text" value={dependentForm.policy_id} disabled />
                                </div>
                                <div className="add-dependent-field">
                                    <label>gst</label>
                                    <input type="text" value={dependentForm.gst} disabled />
                                </div>
                            </div>

                        </div>

                        {/* ================= Spouse ================= */}
                        {allowedRelations.spouse && (
                            <div className="add-dependent-section">
                                <div className="add-dependent-section-title">Spouse</div>

                                <div className="add-dependent-row">
                                    <div className="add-dependent-field">
                                        <label>Name</label>
                                        <input
                                            placeholder="Spouse Name"
                                            value={dependentForm.spouse_name}
                                            onChange={(e) =>
                                                setDependentForm({ ...dependentForm, spouse_name: e.target.value })
                                            }
                                        />
                                    </div>

                                    <div className="add-dependent-field">
                                        <label>DOB</label>
                                        <input
                                            type="date"
                                            min={minDate}
                                            max={maxDate}
                                            value={dependentForm.spouse_dob}
                                            onChange={(e) =>
                                                setDependentForm({ ...dependentForm, spouse_dob: e.target.value })
                                            }
                                        />

                                    </div>
                                </div>
                            </div>
                        )}

                        {/* ================= Children ================= */}
                        {allowedRelations.children > 0 && (
                            <div className="add-dependent-section">
                                <div className="add-dependent-section-title">Children</div>

                                {[...Array(allowedRelations.children)].map((_, i) => {
                                    const nameKey = i === 0 ? "child_name" : `child${i + 1}_name`;
                                    const dobKey = i === 0 ? "child_dob" : `child${i + 1}_dob`;

                                    return (
                                        <div className="add-dependent-row" key={i}>
                                            <div className="add-dependent-field">
                                                <label>Child {i + 1} Name</label>
                                                <input
                                                    value={dependentForm[nameKey] || ""}
                                                    onChange={(e) =>
                                                        setDependentForm({ ...dependentForm, [nameKey]: e.target.value })
                                                    }
                                                />
                                            </div>

                                            <div className="add-dependent-field">
                                                <label>DOB</label>
                                                <input
                                                    type="date"
                                                    min={minDate}
                                                    max={maxDate}
                                                    value={dependentForm[dobKey] || ""}
                                                    onChange={(e) =>
                                                        setDependentForm({ ...dependentForm, [dobKey]: e.target.value })
                                                    }
                                                />

                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        )}

                        {/* ================= Parents ================= */}
                        {allowedRelations.parents && (
                            <div className="add-dependent-section">
                                <div className="add-dependent-section-title">Parents</div>

                                <div className="add-dependent-row">
                                    <div className="add-dependent-field">
                                        <label>Father Name</label>
                                        <input
                                            value={dependentForm.father_name}
                                            onChange={(e) =>
                                                setDependentForm({ ...dependentForm, father_name: e.target.value })
                                            }
                                        />
                                    </div>

                                    <div className="add-dependent-field">
                                        <label>DOB</label>
                                        <input
                                            type="date"
                                            value={dependentForm.father_dob}
                                            onChange={(e) =>
                                                setDependentForm({ ...dependentForm, father_dob: e.target.value })
                                            }
                                        />
                                    </div>
                                </div>

                                <div className="add-dependent-row">
                                    <div className="add-dependent-field">
                                        <label>Mother Name</label>
                                        <input
                                            value={dependentForm.mother_name}
                                            onChange={(e) =>
                                                setDependentForm({ ...dependentForm, mother_name: e.target.value })
                                            }
                                        />
                                    </div>

                                    <div className="add-dependent-field">
                                        <label>DOB</label>
                                        <input
                                            type="date"
                                            value={dependentForm.mother_dob}
                                            onChange={(e) =>
                                                setDependentForm({ ...dependentForm, mother_dob: e.target.value })
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* ================= In-Laws ================= */}
                        {allowedRelations.inlaws && (
                            <div className="add-dependent-section">
                                <div className="add-dependent-section-title">In-Laws</div>

                                <div className="add-dependent-row">
                                    <div className="add-dependent-field">
                                        <label>Father-in-law</label>
                                        <input
                                            value={dependentForm.father_inlaw_name}
                                            onChange={(e) =>
                                                setDependentForm({ ...dependentForm, father_inlaw_name: e.target.value })
                                            }
                                        />
                                    </div>

                                    <div className="add-dependent-field">
                                        <label>DOB</label>
                                        <input
                                            type="date"
                                            value={dependentForm.father_inlaw_dob}
                                            onChange={(e) =>
                                                setDependentForm({ ...dependentForm, father_inlaw_dob: e.target.value })
                                            }
                                        />
                                    </div>
                                </div>

                                <div className="add-dependent-row">
                                    <div className="add-dependent-field">
                                        <label>Mother-in-law</label>
                                        <input
                                            value={dependentForm.mother_inlaw_name}
                                            onChange={(e) =>
                                                setDependentForm({ ...dependentForm, mother_inlaw_name: e.target.value })
                                            }
                                        />
                                    </div>

                                    <div className="add-dependent-field">
                                        <label>DOB</label>
                                        <input
                                            type="date"
                                            value={dependentForm.mother_inlaw_dob}
                                            onChange={(e) =>
                                                setDependentForm({ ...dependentForm, mother_inlaw_dob: e.target.value })
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                        )}

                         <p style={{ color: "#d9534f", fontSize: "13px", marginBottom: "80px" }}>
                            <b>Note:</b> Dependents can be added only if a scheme is assigned to the employee.
                        </p>

                        {/* ================= Actions ================= */}
                        <div className="add-dependent-actions">
                            <button
                                className="add-dependent-btn-cancel"
                                onClick={() => setShowAddDependentPopup(false)}
                            >
                                Cancel
                            </button>

                            <button
                                className="add-dependent-btn-save"
                                onClick={handleUpdateDependent}
                            >
                                Save
                            </button>
                        </div>

                    </div>
                </div>
            )}
            {/* {showPanel && (
                <div className="insurer-panel">

                   
                    <div className="popup-header">
                        <h4>Insurer Contact Details</h4>
                        <button
                            className="close-btn"
                            onClick={() => setShowPanel(false)}
                        >
                            ✖
                        </button>
                    </div>

                   
                    <button
                        className="download-btn"
                        onClick={downloadEmployeeExcel}
                    >
                        ⬇ Download Excel of additional/deletion of employee
                    </button>

                    
                    {contacts.length > 0 ? (
                        contacts.map((contact, index) => (
                            <div key={index} className="contact-row">

                                
                                <input
                                    type="text"
                                    placeholder="Insurer"
                                    value={contact.insurer || ""}
                                    disabled   // insurer comes from backend
                                />

                              
                                <input
                                    type="text"
                                    placeholder="Insurer Contact Name"
                                    value={contact.contactName || ""}
                                    onChange={(e) =>
                                        updateInsurerContact(index, "contactName", e.target.value)
                                    }
                                />

                                <input
                                    type="email"
                                    placeholder="Insurer Email"
                                    value={contact.contactEmail || ""}
                                    onChange={(e) =>
                                        updateInsurerContact(index, "contactEmail", e.target.value)
                                    }
                                />

                               
                                <label className="attach-icon">
                                    📎
                                    <input
                                        type="file"
                                        hidden
                                        onChange={(e) =>
                                            updateAttachment(index, e.target.files[0])
                                        }
                                    />
                                </label>

                              
                                {contact.attachment && (
                                    <span className="file-name">
                                        {contact.attachment.name}
                                    </span>
                                )}

                              
                                <button
                                    className="send-btn"
                                    onClick={() => handleSendToInsurer(index)}
                                >
                                    Send
                                </button>

                            </div>
                        ))
                    ) : (
                        <p>No pending insurers found.</p>
                    )}
                </div>
            )} */}

            {/* {showEndorsementPopup && (
                <div className="endorsement-popup-overlay">
                    <div className="endorsement-popup">

                        <div className="popup-header">
                            <h3>Sent Endorsements</h3>
                            <button onClick={() => setShowEndorsementPopup(false)}>✖</button>
                        </div>

                        <table className="endorsement-table">
                            <thead>
                                <tr>
                                    <th>Employee Name</th>
                                    <th>Scheme Name</th>
                                    <th>Sum Insured</th>
                                    <th>Premium</th>
                                   
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>

                            <tbody>
                                {sentEndorsements.length === 0 ? (
                                    <tr>
                                        <td colSpan="6" style={{ textAlign: "center" }}>
                                            No Sent Endorsements
                                        </td>
                                    </tr>
                                ) : (
                                    sentEndorsements.map((row) => (
                                        <tr key={row.id}>
                                            <td>{row.emp_name}</td>
                                            <td>{row.scheme_name}</td>
                                            <td>{row.sum_insured}</td>
                                            <td>{row.total_premium}</td>
                                            
                                            <td>{row.status}</td>
                                            <td>
                                                <button
                                                    className="edit-btn"
                                                //onClick={() => handleEditEndorsement(row)}
                                                >
                                                    Edit
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>

                    </div>
                </div>
            )} */}

            {/* {showEndorsementPopup && (
                <div className="endorsement-popup-overlay">
                    <div className="endorsement-popup">

                        <div className="popup-header">
                            <h3>Sent Endorsements</h3>
                            <button onClick={() => setShowEndorsementPopup(false)}>✖</button>
                        </div>

                        <table className="endorsement-table">
                            <thead>
                                <tr>
                                    <th>Emp ID</th>
                                    <th>Employee Name</th>
                                    <th>Scheme Name</th>
                                    <th>Sum Insured</th>
                                     <th>Insurer</th>
                                    <th>Premium</th>
                                    <th>gst</th>
                                    <th>total premium</th>
                                    <th>Remarks</th>
                                    <th>Status</th>

                                </tr>
                            </thead>

                            <tbody>
                                {sentEndorsements.length === 0 ? (
                                    <tr>
                                        <td colSpan="6" style={{ textAlign: "center" }}>
                                            No Sent Endorsements
                                        </td>
                                    </tr>
                                ) : (
                                    sentEndorsements.map((row) => (
                                        <tr key={row.id}>
                                            <td>{row.emp_id}</td>
                                            <td>{row.emp_name}</td>
                                            <td>{row.scheme_name}</td>
                                            <td>{row.sum_insured}</td>
                                            <td>{row.insurer}</td>
                                            <td>{row.premium}</td>
                                            <td>{row.gst}</td>
                                            <td>{row.total_premium}</td>
                                            <td>{row.remarks}</td>
                                            <td>{row.status}</td>

                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>

                    </div>
                </div>
            )} */}

{showEndorsementPopup && (
  <div className="endorsement-popup-overlay">
    <div className="endorsement-popup">

      {/* HEADER */}
      <div className="popup-header">
        <h3>Sent Pending Endorsements</h3>

        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
          
          {/* Filter Icon */}
          <div
            className="filter-section"
            onClick={() => setShowFilter(!showFilter)}
          >
            <span className="filter-icon">⏷</span>
            <span className="filter-label">Filter Insurer</span>
          </div>

          {/* Send Mail */}
          <button
            className="endorsement-send-btn"
            onClick={handleSendMail}
            disabled={sendingMail}
          >
            {sendingMail ? "Sending..." : "Send Mail"}
          </button>

          {/* Close */}
          <button
            className="popup-close"
            onClick={() => setShowEndorsementPopup(false)}
          >
            ✖
          </button>
        </div>
      </div>

      {/* FILTER */}
      {showFilter && (
        <div className="filter-dropdown">
          <select
            value={selectedInsurer}
            onChange={(e) => setSelectedInsurer(e.target.value)}
          >
            <option value="">All Insurers</option>
            {insurerList.map((ins, index) => (
              <option key={index} value={ins}>
                {ins}
              </option>
            ))}
          </select>
        </div>
      )}

      {/* 🔥 TABLE + TOTAL */}
      <div className="table-wrapper">

        {/* ✅ CALCULATE TOTAL */}
        {(() => {
          const totalPremiumSum = filteredEndorsements.reduce(
            (sum, row) => sum + Number(row.total_premium || 0),
            0
          );

          return (
            <>
              <table className="endorsement-table">

    <thead>
        <tr>
            <th>Emp ID</th>
            <th>Employee Name</th>
            <th>Scheme</th>
            <th>Insurer</th>
            <th>Sum Insured</th>
            <th>Premium</th>
            <th>GST</th>
            <th>Total Premium</th>
            <th>Remarks</th>
            <th>Status</th>

            <th>Spouse</th>

            <th>Child 1</th>
            <th>Child 2</th>
            <th>Child 3</th>

            <th>Father</th>
            <th>Mother</th>

            <th>Father Inlaw</th>
            <th>Mother Inlaw</th>
        </tr>
    </thead>

    <tbody>

        {filteredEndorsements.length === 0 ? (

            <tr>
                <td colSpan={17} style={{ textAlign: "center" }}>
                    No Pending Endorsements
                </td>
            </tr>

        ) : (

            filteredEndorsements.map((row) => (

                <tr key={row.id}>

                    <td>{row.emp_id}</td>

                    <td>{row.emp_name}</td>

                    <td>{row.scheme_id}</td>

                    <td>{row.insurer}</td>

                    <td>{row.sum_insured}</td>

                    <td>{row.premium}</td>

                    <td>{row.gst}</td>

                    <td>{row.total_premium}</td>

                    <td>{row.remarks}</td>

                    <td>{row.status}</td>

                    {/* SPOUSE */}
                    <td>
                        {row.spouse_name
                            ? (
                                <>
                                    <div>{row.spouse_name}</div>
                                    <div>
    {row.spouse_dob
        ? row.spouse_dob.split("T")[0]
        : "-"
    }
</div>
                                </>
                            )
                            : "-"
                        }
                    </td>

                    {/* CHILD 1 */}
                    <td>
                        {row.child_name
                            ? (
                                <>
                                    <div>{row.child_name}</div>
                                    <div>
    {row.child_dob
        ? row.child_dob.split("T")[0]
        : "-"
    }
</div>
                                </>
                            )
                            : "-"
                        }
                    </td>

                    {/* CHILD 2 */}
                    <td>
                        {row.child2_name
                            ? (
                                <>
                                    <div>{row.child2_name}</div>
                                    <div>
    {row.child2_dob
        ? row.child2_dob.split("T")[0]
        : "-"
    }
</div>
                                </>
                            )
                            : "-"
                        }
                    </td>

                    {/* CHILD 3 */}
                    <td>
                        {row.child3_name
                            ? (
                                <>
                                    <div>{row.child3_name}</div>
                                    <div>
    {row.child3_dob
        ? row.child3_dob.split("T")[0]
        : "-"
    }
</div>
                                </>
                            )
                            : "-"
                        }
                    </td>

                    {/* FATHER */}
                    <td>
                        {row.father_name
                            ? (
                                <>
                                    <div>{row.father_name}</div>
                                    <div>
    {row.father_dob
        ? row.father_dob.split("T")[0]
        : "-"
    }
</div>
                                </>
                            )
                            : "-"
                        }
                    </td>

                    {/* MOTHER */}
                    <td>
                        {row.mother_name
                            ? (
                                <>
                                    <div>{row.mother_name}</div>
                                    <div>
    {row.mother_dob
        ? row.mother_dob.split("T")[0]
        : "-"
    }
</div>
                                </>
                            )
                            : "-"
                        }
                    </td>

                    {/* FATHER INLAW */}
                    <td>
                        {row.father_inlaw_name
                            ? (
                                <>
                                    <div>{row.father_inlaw_name}</div>
                                    <div>
    {row.father_inlaw_dob
        ? row.father_inlaw_dob.split("T")[0]
        : "-"
    }
</div>
                                </>
                            )
                            : "-"
                        }
                    </td>

                    {/* MOTHER INLAW */}
                    <td>
                        {row.mother_inlaw_name
                            ? (
                                <>
                                    <div>{row.mother_inlaw_name}</div>
                                    <div>
    {row.mother_inlaw_dob
        ? row.mother_inlaw_dob.split("T")[0]
        : "-"
    }
</div>
                                </>
                            )
                            : "-"
                        }
                    </td>

                </tr>
            ))
        )}

    </tbody>

</table>

              {/* ✅ TOTAL DISPLAY */}
              <div
                style={{
                  marginTop: "10px",
                  textAlign: "right",
                  fontWeight: "bold",
                  fontSize: "16px"
                }}
              >
                Total Premium: ₹ {totalPremiumSum.toFixed(2)}
              </div>
            </>
          );
        })()}

      </div>
    </div>
  </div>
)}
            {showViewDependentPopup && viewDependentData && (
                <div className="add-dependent-overlay">
                    <div className="add-dependent-modal" style={{ width: "90%" }}>

                        <h3 className="add-dependent-title">View Dependency</h3>

                        <table className="dependency-table">
                            <thead>
                                <tr>
                                    <th>Emp ID</th>
                                    <th>Emp Name</th>
                                    <th>Scheme ID</th>
                                    <th>Family Definition</th>
                                    <th>Policy Start Date</th>
                                    <th>Policy End Date</th>
                                    <th>Sum Insured</th>
                                    <th>Policy ID</th>
                                    <th>Insurer</th>
                                    <th>Premium</th>
                                    <th>GST Amount</th>
                                    <th>Total Premium</th>

                                    {allowedRelations.spouse && (
                                        <>
                                            <th>Spouse Name</th>
                                            <th>Spouse DOB</th>
                                        </>
                                    )}
                                    {allowedRelations.children > 0 &&
                                        [...Array(allowedRelations.children)].map((_, i) => (
                                            <React.Fragment key={i}>
                                                <th>Child {i + 1} Name</th>
                                                <th>Child {i + 1} DOB</th>
                                            </React.Fragment>
                                        ))}
                                    {allowedRelations.parents && (
                                        <>
                                            <th>Father Name</th>
                                            <th>Father DOB</th>
                                            <th>Mother Name</th>
                                            <th>Mother DOB</th>
                                        </>
                                    )}
                                    {allowedRelations.inlaws && (
                                        <>
                                            <th>Father-in-law</th>
                                            <th>Father-in-law DOB</th>
                                            <th>Mother-in-law</th>
                                            <th>Mother-in-law DOB</th>
                                        </>
                                    )}
                                </tr>
                            </thead>


                            <tbody>
                                <tr>
                                    <td>{viewDependentData.emp_id}</td>
                                    <td>{viewDependentData.emp_name}</td>
                                    <td>{viewDependentData.scheme_id}</td>
                                    <td>{viewDependentData.family_definition}</td>
                                    <td>{viewDependentData.policy_start_date}</td>
                                    <td>{viewDependentData.policy_end_date}</td>
                                    <td>{viewDependentData.total_sum_insured}</td>
                                    <td>{viewDependentData.policy_id}</td>
                                    <td>{viewDependentData.insurer}</td>
                                    <td>{viewDependentData.premium}</td>
                                    <td>{viewDependentData.gst}</td> {/* gstAmount */}
                                    <td>{viewDependentData.total_premium}</td>

                                    {allowedRelations.spouse && (
                                        <>
                                            <td>{viewDependentData.spouse_name}</td>
                                            <td>{viewDependentData.spouse_dob}</td>
                                        </>
                                    )}
                                    {allowedRelations.children > 0 &&
                                        [...Array(allowedRelations.children)].map((_, i) => {
                                            const nameKey = i === 0 ? "child_name" : `child${i + 1}_name`;
                                            const dobKey = i === 0 ? "child_dob" : `child${i + 1}_dob`;

                                            return (
                                                <React.Fragment key={i}>
                                                    <td>{viewDependentData[nameKey]}</td>
                                                    <td>{viewDependentData[dobKey]}</td>
                                                </React.Fragment>
                                            );
                                        })}
                                    {allowedRelations.parents && (
                                        <>
                                            <td>{viewDependentData.father_name}</td>
                                            <td>{viewDependentData.father_dob}</td>
                                            <td>{viewDependentData.mother_name}</td>
                                            <td>{viewDependentData.mother_dob}</td>
                                        </>
                                    )}
                                    {allowedRelations.inlaws && (
                                        <>
                                            <td>{viewDependentData.father_inlaw_name}</td>
                                            <td>{viewDependentData.father_inlaw_dob}</td>
                                            <td>{viewDependentData.mother_inlaw_name}</td>
                                            <td>{viewDependentData.mother_inlaw_dob}</td>
                                        </>
                                    )}
                                </tr>
                            </tbody>

                        </table>

                        {/* ================= PREMIUM ================= */}


                        <div className="add-dependent-actions">
                            <button
                                className="add-dependent-btn-save"
                                onClick={() => setShowViewDependentPopup(false)}
                            >
                                Close
                            </button>

                            <button
                                className="add-dependent-btn-save"
                                onClick={handleSaveToEndorsement}
                            >
                                Save
                            </button>

                        </div>

                    </div>
                </div>
            )}

{/* {showCdPopup && (
    <div className="cd-popup-overlay">
        <div className="cd-popup-box">
            <h3>Insufficient CD Balance</h3>

            <p><strong>Insurer:</strong> {cdPopupData.insurer}</p>
            <p><strong>Available Balance:</strong> ₹{cdPopupData.balance}</p>
            <p><strong>Required Premium:</strong> ₹{cdPopupData.required}</p>

            <p style={{ color: "red", fontWeight: "bold" }}>
                Not enough CD balance to proceed.
            </p>

            <button onClick={() => setShowCdPopup(false)}>
                Close
            </button>
        </div>
    </div>
)} */}


{showCdPopup && (
    <div className="cd-popup-overlay">
        <div className="cd-popup-box">
            <h3>Insufficient CD Balance</h3>

            <p><strong>Insurer:</strong> {cdPopupData.insurer}</p>
            <p><strong>Available Balance:</strong> ₹{cdPopupData.balance}</p>
            <p><strong>Required Premium:</strong> ₹{cdPopupData.required}</p>

            <p style={{ color: "red", fontWeight: "bold" }}>
                Not enough CD balance to proceed.
            </p>

            {/* ✅ NEW FORM */}
            <div className="cd-add-form">
                <input
  type="text"
  value={cdForm.date}
  readOnly
/>

<input
  type="text"
  placeholder="Receipt No"
  value={cdForm.receiptNo}
  maxLength={15}   // ✅ limit
  onChange={(e) =>
    setCdForm({ ...cdForm, receiptNo: e.target.value })
  }
/>

<input
    type="text"
    placeholder="Amount"
    value={cdForm.amount}
    onChange={(e) =>
        handleCdAmountChange(e.target.value)
    }
/>

<button onClick={handleAddAmount}>Add Amount</button>
            </div>

            {/* ✅ BUTTONS */}
          

            <button onClick={() => setShowCdPopup(false)}>
                Close
            </button>
        </div>
    </div>
)}

{showDeactiveEmployeePopup && (
<div className="endorsement-popup-overlay">

<div className="endorsement-popup">

    {/* HEADER */}
    <div className="popup-header">

        <h3>Pending Employee Deletion List</h3>

        <div
            style={{
                display: "flex",
                gap: "10px",
                alignItems: "center"
            }}
        >

            {/* Filter */}
            <div
                className="filter-section"
                onClick={() => setShowDeleteFilter(!showDeleteFilter)}
            >
                <span className="filter-icon">⏷</span>
                <span className="filter-label">Filter Insurer</span>
            </div>

            {/* Send Mail */}
            <button
                className="endorsement-send-btn"
                onClick={handledeletionSendMail}
                disabled={sendingDeletionMail}
            >
                {sendingDeletionMail ? "Sending..." : "Send Mail"}
            </button>

            {/* Inactive User Button */}
            <button
                className="endorsement-send-btn"
                onClick={handleInactiveUserBalance}
            >
                Inactive User
            </button>

            {/* Close */}
            <button
                className="popup-close"
                onClick={() => setShowDeactiveEmployeePopup(false)}
            >
                ✖
            </button>

        </div>
    </div>

    {/* FILTER DROPDOWN */}
    {showDeleteFilter && (

        <div className="filter-dropdown">

            <select
                value={selectedDeleteInsurer}
                onChange={(e) =>
                    setSelectedDeleteInsurer(e.target.value)
                }
            >

                <option value="">All Insurers</option>

                {deleteInsurerList.map((ins, index) => (
                    <option key={index} value={ins}>
                        {ins}
                    </option>
                ))}

            </select>

        </div>
    )}

    {/* TABLE */}
    <div className="table-wrapper">

        <table className="endorsement-table">

            <thead>
                <tr>

                    <th>Emp ID</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Scheme</th>
                    <th>Insurer</th>

                    <th>Joining Date</th>
                    <th>Designation</th>
                    <th>Phone</th>

                    <th>Sum Insured</th>
                    <th>Balance SI</th>

                    <th>Policy Start</th>
                    <th>Policy End</th>

                    <th>Premium</th>
                    <th>GST</th>
                    <th>Total Premium</th>

                    <th>Last Working Date</th>
                    <th>Status</th>
                    <th>Remaining Balance</th>

                </tr>
            </thead>

            <tbody>

                {filteredDeleteEmployees.length === 0 ? (

                    <tr>
                        <td
                            colSpan="20"
                            style={{ textAlign: "center" }}
                        >
                            No Inactive Employees
                        </td>
                    </tr>

                ) : (

                    filteredDeleteEmployees.map((emp, index) => (

                        <tr key={index}>

                            <td>{emp.emp_id}</td>

                            <td>{emp.emp_name}</td>

                            <td>{emp.emp_email_id}</td>

                            <td>{emp.scheme_name}</td>

                            <td>{emp.insurer}</td>

                            <td>{formatDate(emp.joining_date)}</td>

                            <td>{emp.designation}</td>

                            <td>{emp.phone_number}</td>

                            <td>{emp.sum_insured}</td>

                            <td>{emp.sum_insured_bal}</td>

                            <td>
                                {formatDate(emp.policy_start_date)}
                            </td>

                            <td>
                                {formatDate(emp.policy_end_date)}
                            </td>

                            <td>{emp.premium}</td>

                            <td>{emp.gst}</td>

                            <td>{emp.total_premium}</td>

                            <td>
                                {formatDate(emp.last_working_date)}
                            </td>

                            <td>{emp.emp_status}</td>

                            <td>
                                <strong>
                                    ₹{" "}
                                    {Number(
                                        emp.remaining_balance || 0
                                    ).toFixed(2)}
                                </strong>
                            </td>

                        </tr>

                    ))
                )}

            </tbody>

        </table>

    </div>

    {/* TOTAL REMAINING BALANCE */}

    <div
        style={{
            marginTop: "20px",
            textAlign: "right",
            fontWeight: "bold",
            fontSize: "18px"
        }}
    >

        Total Remaining Balance :

        <span
            style={{
                color: "#0f766e",
                marginLeft: "10px"
            }}
        >
            ₹{" "}
            {Number(
                deleteTotalRemainingBalance
            ).toLocaleString("en-IN", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })}
        </span>

    </div>

</div>
</div>
)}
        </div>
    );
};

export default EmployeeManagement;
